import {css} from '@emotion/react'

const adyen_css = css`
    .adyen-checkout__input {
        --adyen-sdk-spacer-110: 45px;
    }
    .js-iframe {
        border: none;
        height: 100%;
        overflow: hidden;
        width: 100%;
    }
    .adyen-checkout-card-input__wrapper {
        position: relative;
    }
    .adyen-checkout-card-input__icon {
        border-radius: var(--adyen-sdk-border-radius-s, 4px);
        height: 18px;
        margin-right: var(--adyen-sdk-spacer-060, 12px);
        width: 27px;
    }
    .adyen-checkout-card-input__form {
        opacity: 1;
    }
    .adyen-checkout-card-input__spinner {
        display: none;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 1;
    }
    .adyen-checkout-card-input__spinner--active {
        display: block;
    }
    .adyen-checkout-card-input__form--loading {
        opacity: 0;
    }
    .adyen-checkout__input {
        display: block;
        max-height: 100px;
    }
    .adyen-checkout__field.adyen-checkout__card__cvc__input--hidden,
    .adyen-checkout__field.adyen-checkout__card__exp-date__input--hidden {
        display: none;
    }
    .adyen-checkout__card__exp-cvc__exp-date__input--hidden {
        justify-content: flex-end;
    }
    .revolving-plan-installments__disabled {
        opacity: 0.4;
        pointer-events: none;
    }
    .adyen-checkout__card-input__form {
        transition: opacity 0.25s ease-out;
    }
    .adyen-checkout__card__cardNumber {
        max-width: 400px;
    }
    .adyen-checkout__card__cardNumber__input {
        padding-left: var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout__card__exp-date__input--oneclick {
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        line-height: var(--adyen-sdk-text-title-line-height, 26px);
        overflow: hidden;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .adyen-checkout__card__holderName,
    .adyen-checkout__field--expiryDate,
    .adyen-checkout__field--storedCard {
        margin-bottom: 0;
    }
    .adyen-checkout__card-input .adyen-checkout__fieldset--billingAddress,
    .adyen-checkout__card__holderName,
    .adyen-checkout__card__kcp-authentication,
    .adyen-checkout__card__socialSecurityNumber,
    .adyen-checkout__installments {
        margin-top: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__card-input.adyen-checkout__card-input--loading {
        pointer-events: none;
    }
    .adyen-checkout__card__holderName:first-of-type {
        margin: 0 0 var(--adyen-sdk-spacer-060, 16px);
    }
    .adyen-checkout__field--cardNumber .adyen-checkout-card-input__icon--hidden,
    .adyen-checkout__field--cardNumber
        .adyen-checkout__input--error
        + .adyen-checkout__card__cardNumber__brandIcon,
    .adyen-checkout__field--cardNumber
        .adyen-checkout__input--valid:not(.adyen-checkout__card__cardNumber__input--noBrand)
        + .adyen-checkout-input__inline-validation--valid {
        display: none;
    }
    .adyen-checkout__field--securityCode.adyen-checkout__field--error
        .adyen-checkout__card__cvc__hint,
    .adyen-checkout__field--securityCode.adyen-checkout__field--valid
        .adyen-checkout__card__cvc__hint {
        opacity: 0;
    }
    @keyframes cvc-indicate-location {
        0% {
            opacity: 1;
        }
        to {
            opacity: 0.3;
        }
    }
    .adyen-checkout__label--focused
        .adyen-checkout__field__cvc--back-hint
        .adyen-checkout__card__cvc__hint--back
        .adyen-checkout__card__cvc__hint__location,
    .adyen-checkout__label--focused
        .adyen-checkout__field__cvc--front-hint
        .adyen-checkout__card__cvc__hint--front
        .adyen-checkout__card__cvc__hint__location {
        animation-direction: alternate;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-name: cvc-indicate-location;
    }
    .adyen-checkout__card__cvc__hint__wrapper {
        align-items: center;
        backface-visibility: visible;
        display: flex;
        height: 100%;
        margin-right: var(--adyen-sdk-spacer-060, 12px);
        position: absolute;
        right: 0;
        transform: translateZ(0);
        transform-origin: center;
        transform-style: preserve-3d;
        transition: transform 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955);
        width: 27px;
        will-change: transform;
    }
    .adyen-checkout__field__cvc--front-hint.adyen-checkout__card__cvc__hint__wrapper {
        transform: rotateY(180deg);
    }
    .adyen-checkout__card__cvc__hint {
        backface-visibility: hidden;
        position: absolute;
        transition: opacity 0.1s linear;
    }
    .adyen-checkout__field__exp-date_hint_wrapper {
        align-items: center;
        display: flex;
        margin-right: var(--adyen-sdk-spacer-060, 12px);
        position: absolute;
        right: 0;
        transition: opacity 0.1s linear;
    }
    .adyen-checkout__field__exp-date_hint_wrapper.adyen-checkout__field__exp-date_hint_wrapper--hidden {
        opacity: 0;
    }
    .adyen-checkout__field__exp-date_hint {
        height: 18px;
        width: 27px;
    }
    .adyen-checkout__card__cvc__hint--front {
        transform: rotateY(180deg);
    }
    @media (prefers-reduced-motion: reduce) {
        .adyen-checkout__card__cvc__hint__wrapper {
            transition: none;
        }
    }
    .adyen-checkout__fieldset--revolving-plan .adyen-checkout__fieldset__fields {
        justify-content: left;
    }
    .adyen-checkout__fieldset--revolving-plan .adyen-checkout__radio_group {
        display: flex;
        flex-direction: column;
    }
    .adyen-checkout__fieldset--revolving-plan .adyen-checkout__radio_group__input-wrapper {
        margin-top: var(--adyen-sdk-spacer-080, 20px);
    }
    .adyen-checkout__fieldset--revolving-plan .adyen-checkout__field--revolving-plan-installments {
        margin-left: var(--adyen-sdk-spacer-070, 16px);
        position: relative;
        top: 52px;
        width: 30%;
    }
    .adyen-checkout__spinner__wrapper {
        align-items: center;
        display: flex;
        height: 100%;
        justify-content: center;
    }
    .adyen-checkout__spinner__wrapper--inline {
        display: inline-block;
        height: auto;
        margin-right: var(--adyen-sdk-spacer-040, 8px);
    }
    [dir='rtl'] .adyen-checkout__spinner__wrapper--inline {
        margin-left: var(--adyen-sdk-spacer-040, 8px);
        margin-right: 0;
    }
    .adyen-checkout__spinner {
        height: var(--adyen-sdk-spacer-090, 24px);
        position: relative;
        width: var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen-checkout__spinner:after,
    .adyen-checkout__spinner:before {
        animation: rotate 1s cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
        border: var(--adyen-sdk-border-width-l, 3px) solid transparent;
        border-radius: 50%;
        box-sizing: border-box;
        content: '';
        display: block;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }
    .adyen-checkout__spinner:before {
        border-color: var(--adyen-sdk-color-background-inverse-primary, #00112c);
        border-top-color: transparent;
        opacity: 0.1;
    }
    .adyen-checkout__spinner:after {
        border-color: transparent;
        border-top-color: var(--adyen-sdk-color-outline-primary-active, #00112c);
    }
    .adyen-checkout__spinner--small {
        height: var(--adyen-sdk-spacer-070, 16px);
        width: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__spinner--small:after,
    .adyen-checkout__spinner--small:before {
        border-width: var(--adyen-sdk-spacer-010, 2px);
    }
    .adyen-checkout__spinner--medium {
        height: 28px;
        width: 28px;
    }
    .adyen-checkout__spinner--large {
        height: var(--adyen-sdk-spacer-120, 48px);
        width: var(--adyen-sdk-spacer-120, 48px);
    }
    .adyen-checkout__spinner--large:after,
    .adyen-checkout__spinner--large:before {
        border-width: var(--adyen-sdk-spacer-020, 4px);
    }
    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(1turn);
        }
    }
    .loading-input__form {
        opacity: 1;
    }
    .loading-input__form--loading {
        opacity: 0;
    }
    .loading-input__spinner {
        display: none;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 1;
    }
    .loading-input__spinner--active {
        display: block;
    }
    .adyen-checkout__field {
        display: block;
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
        width: 100%;
    }
    .adyen-checkout__field--no-borders .adyen-checkout__input-wrapper {
        background-color: transparent;
        border: none;
        box-shadow: none;
    }
    .adyen-checkout__field--no-borders .adyen-checkout__input-wrapper:active,
    .adyen-checkout__field--no-borders .adyen-checkout__input-wrapper:active:hover,
    .adyen-checkout__field--no-borders .adyen-checkout__input-wrapper:focus-within,
    .adyen-checkout__field--no-borders .adyen-checkout__input-wrapper:focus-within:hover {
        border: none;
        box-shadow: none;
    }
    .adyen-checkout__field--no-borders .adyen-checkout__input-wrapper:hover {
        border: none;
        box-shadow: none;
    }
    .adyen-checkout__input-wrapper {
        align-items: center;
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-primary, #dbdee2);
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        display: flex;
        position: relative;
    }
    .adyen-checkout__input-wrapper div,
    .adyen-checkout__input-wrapper input,
    .adyen-checkout__input-wrapper span {
        border-radius: inherit;
    }
    .adyen-checkout__input-wrapper button,
    .adyen-checkout__input-wrapper div,
    .adyen-checkout__input-wrapper input {
        border: none;
    }
    .adyen-checkout__input-wrapper:active,
    .adyen-checkout__input-wrapper:active:hover,
    .adyen-checkout__input-wrapper:focus-within,
    .adyen-checkout__input-wrapper:focus-within:hover {
        border-color: var(--adyen-sdk-color-outline-primary-active, #00112c);
        box-shadow: 0 0 0 0.5px var(--adyen-sdk-color-outline-primary-active, #00112c);
    }
    .adyen-checkout__input-wrapper:hover {
        border-color: var(--adyen-sdk-color-outline-tertiary, #8d95a3);
    }
    .adyen-checkout__field--inactive > .adyen-checkout__input-wrapper {
        background: var(--adyen-sdk-color-background-disabled, #eeeff1);
        border-color: transparent;
    }
    .adyen-checkout__field--error
        > :not(.adyen-checkout__label--focused)
        + .adyen-checkout__input-wrapper:not(:focus-within, :active) {
        border-color: var(--adyen-sdk-color-outline-critical, #e22d2d);
    }
    .adyen-checkout__label {
        display: block;
        position: relative;
    }
    .adyen-checkout__label--focused + .adyen-checkout__input-wrapper {
        border-color: var(--adyen-sdk-color-outline-primary-active, #00112c);
        box-shadow: 0 0 0 0.5px var(--adyen-sdk-color-outline-primary-active, #00112c);
    }
    .adyen-checkout__label--disabled + .adyen-checkout__input-wrapper {
        background: var(--adyen-sdk-color-background-disabled, #eeeff1);
        border-color: transparent;
    }
    .adyen-checkout__helper-text {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        display: block;
        font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin-bottom: var(--adyen-sdk-spacer-020, 4px);
    }
    .adyen-checkout__label-adornment--end {
        position: absolute;
        right: 0;
        top: 0;
    }
    .adyen-checkout__label__text {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        display: block;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        line-height: var(--adyen-sdk-text-body-line-height, 20px);
        margin-bottom: var(--adyen-sdk-spacer-020, 4px);
        overflow: hidden;
        text-overflow: ellipsis;
        transition: color 0.1s ease-out;
        white-space: nowrap;
    }
    .adyen-checkout__label__text--error {
        color: var(--adyen-sdk-color-label-critical, #c72727);
    }
    .adyen-checkout__label--focused .adyen-checkout__label__text {
        color: var(--adyen-sdk-color-label-primary, #00112c);
    }
    .adyen-checkout-contextual-text,
    .adyen-checkout-contextual-text--error {
        align-items: center;
        color: var(--adyen-sdk-color-label-primary, #00112c);
        display: flex;
        font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin-top: var(--adyen-sdk-spacer-020, 4px);
        opacity: 1;
        transition: margin 0.2s ease-out, opacity 0.2s ease-out;
    }
    .adyen-checkout-contextual-text--error {
        color: var(--adyen-sdk-color-label-critical, #c72727);
    }
    .adyen-checkout-contextual-text--hidden {
        height: 0;
        margin: 0;
        opacity: 0;
    }
    .adyen-checkout__filter-input:-webkit-autofill,
    .adyen-checkout__input:-webkit-autofill {
        color: var(--adyen-sdk-color-label-primary, #00112c) !important;
        -webkit-text-fill-color: var(--adyen-sdk-color-label-primary, #00112c) !important;
        -webkit-background-clip: text !important;
        background-clip: text !important;
        background-color: var(--adyen-sdk-color-label-primary, #00112c) !important;
        box-shadow: 0 0 0 1000px var(--adyen-sdk-color-background-primary, #ffffff) inset !important;
        -webkit-transition: none !important;
        transition: none !important;
    }
    .adyen-checkout__filter-input:-webkit-autofill,
    .adyen-checkout__filter-input:-webkit-autofill:active,
    .adyen-checkout__filter-input:-webkit-autofill:focus,
    .adyen-checkout__filter-input:-webkit-autofill:hover,
    .adyen-checkout__filter-input:autofill,
    .adyen-checkout__input:-webkit-autofill,
    .adyen-checkout__input:-webkit-autofill:active,
    .adyen-checkout__input:-webkit-autofill:focus,
    .adyen-checkout__input:-webkit-autofill:hover,
    .adyen-checkout__input:autofill {
        color: var(--adyen-sdk-color-label-primary, #00112c) !important;
        -webkit-text-fill-color: var(--adyen-sdk-color-label-primary, #00112c) !important;
        -webkit-background-clip: text !important;
        background-clip: text !important;
        background-color: var(--adyen-sdk-color-label-primary, #00112c) !important;
        box-shadow: 0 0 0 1000px var(--adyen-sdk-color-background-primary, #ffffff) inset !important;
        -webkit-transition: none !important;
        transition: none !important;
    }
    .adyen-checkout__filter-input,
    .adyen-checkout__input {
        -webkit-background-clip: text !important;
        background-clip: text !important;
        color: var(--adyen-sdk-color-label-primary, #00112c) !important;
    }
    .adyen-checkout__field-wrapper {
        display: flex;
        width: 100%;
    }
    @media (min-width: 480px) {
        .adyen-checkout__field--20 {
            width: 20%;
        }
        .adyen-checkout__field--30 {
            width: 30%;
        }
        .adyen-checkout__field--40 {
            width: 40%;
        }
        .adyen-checkout__field--50 {
            width: 50%;
        }
        .adyen-checkout__field--60 {
            width: 60%;
        }
        .adyen-checkout__field--70 {
            width: 70%;
        }
        .adyen-checkout__field--80 {
            width: 80%;
        }
        .adyen-checkout__field--col-20 {
            width: calc(20% - var(--adyen-sdk-spacer-040, 8px));
        }
        .adyen-checkout__field--col-30 {
            width: calc(30% - var(--adyen-sdk-spacer-040, 8px));
        }
        .adyen-checkout__field--col-40 {
            width: calc(40% - var(--adyen-sdk-spacer-040, 8px));
        }
        .adyen-checkout__field--col-50 {
            width: calc(50% - var(--adyen-sdk-spacer-040, 8px));
        }
        .adyen-checkout__field--col-60 {
            width: calc(60% - var(--adyen-sdk-spacer-040, 8px));
        }
        .adyen-checkout__field--col-70 {
            width: calc(70% - var(--adyen-sdk-spacer-040, 8px));
        }
        .adyen-checkout__field--col-80 {
            width: calc(80% - var(--adyen-sdk-spacer-040, 8px));
        }
    }
    .adyen-checkout__field-wrapper > .adyen-checkout__field:first-of-type {
        margin-right: var(--adyen-sdk-spacer-040, 8px);
    }
    [dir='rtl'] .adyen-checkout__field-wrapper > .adyen-checkout__field:first-of-type {
        margin-left: var(--adyen-sdk-spacer-040, 8px);
        margin-right: 0;
    }
    .adyen-checkout__field-wrapper > .adyen-checkout__field:nth-child(2) {
        margin-left: var(--adyen-sdk-spacer-040, 8px);
    }
    [dir='rtl'] .adyen-checkout__field-wrapper > .adyen-checkout__field:nth-child(2) {
        margin-left: 0;
        margin-right: var(--adyen-sdk-spacer-040, 8px);
    }
    .adyen-checkout__field-wrapper:last-of-type > .adyen-checkout__field {
        margin-bottom: 0;
    }
    .adyen-checkout__input {
        background: inherit;
        color: var(--adyen-sdk-color-label-primary, #00112c);
        display: block;
        font-family: inherit;
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        height: var(--adyen-sdk-spacer-110, 40px);
        outline: none;
        padding-left: var(--adyen-sdk-spacer-060, 12px);
        transition: border 0.2s ease-out, box-shadow 0.2s ease-out;
        width: 100%;
    }
    .adyen-checkout__input:required {
        box-shadow: none;
    }
    .adyen-checkout__input:-moz-read-only {
        color: var(--adyen-sdk-color-label-secondary, #5c687c) !important;
        cursor: default;
    }
    .adyen-checkout__input:disabled,
    .adyen-checkout__input:read-only {
        color: var(--adyen-sdk-color-label-secondary, #5c687c) !important;
        cursor: default;
    }
    span.adyen-checkout__input {
        overflow: hidden;
    }
    .adyen-checkout-input__inline-validation {
        height: var(--adyen-sdk-spacer-070, 16px);
        margin-right: var(--adyen-sdk-spacer-060, 12px);
        width: var(--adyen-sdk-spacer-070, 16px);
    }
    [dir='rtl'] .adyen-checkout-input__inline-validation {
        margin-left: var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout-input__inline-validation > .adyen-checkout__icon {
        display: none;
    }
    .adyen-checkout-input__inline-validation--valid {
        color: var(--adyen-sdk-color-label-success, #07893c);
    }
    .adyen-checkout-input__inline-validation--invalid {
        color: var(--adyen-sdk-color-label-critical, #c72727);
    }
    .adyen-checkout__input--date {
        padding: 0.5em;
    }
    .adyen-checkout__fieldset {
        border: none;
        display: block;
        margin-inline-end: 0;
        margin-inline-start: 0;
        margin: 0;
        padding-block-start: 0;
        padding-bottom: var(--adyen-sdk-spacer-040, 8px);
        padding-block-end: 0;
        padding-inline-end: 0;
        padding-inline-start: 0;
        width: 100%;
    }
    .adyen-checkout__fieldset__description {
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        line-height: 1.5;
        list-style-type: disc;
        margin: 0;
    }
    .adyen-checkout__fieldset:last-of-type {
        padding-bottom: 0;
    }
    .adyen-checkout__fieldset + .adyen-checkout__fieldset {
        margin-top: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__fieldset__title {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        display: block;
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        font-weight: var(--adyen-sdk-text-subtitle-stronger-font-weight, 600);
        font-weight: var(--adyen-sdk-text-subtitle-font-weight, 500);
        line-height: var(--adyen-sdk-text-subtitle-line-height, 26px);
        margin: 0;
        padding: 0 0 var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout__fieldset__title:has(+ .adyen-checkout__fieldset__description) {
        padding: 0;
    }
    .adyen-checkout__field-group,
    .adyen-checkout__fieldset__fields {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
    }
    @media (min-width: 480px) {
        .adyen-checkout__field-group:last-of-type .adyen-checkout__field {
            margin-bottom: 0;
        }
    }
    .adyen-checkout__field-group:last-of-type .adyen-checkout__field:last-of-type,
    :not(.adyen-checkout__field-group) > .adyen-checkout__field:last-of-type {
        margin-bottom: 0;
    }
    .adyen-checkout__fieldset--readonly .adyen-checkout__fieldset__fields {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin: 0;
    }
    .adyen-checkout__radio_group + .adyen-checkout-input__inline-validation {
        display: none;
    }
    .adyen-checkout__radio_group__input {
        opacity: 0;
        position: absolute;
    }
    .adyen-checkout__radio_group__label {
        color: inherit;
        display: block;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: 400;
        line-height: var(--adyen-sdk-text-body-line-height, 20px);
        margin: 0;
        overflow: visible;
        padding-bottom: 0;
        padding-left: var(--adyen-sdk-spacer-090, 24px);
        position: relative;
    }
    .adyen-checkout__label--focused .adyen-checkout__radio_group__label {
        color: inherit;
    }
    .adyen-checkout__radio_group__label:before {
        background-color: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-tertiary, #8d95a3);
        border-radius: 50%;
        content: '';
        height: var(--adyen-sdk-spacer-070, 16px);
        left: 0;
        position: absolute;
        top: var(--adyen-sdk-spacer-010, 2px);
        transition: border-color 0.2s ease-out, box-shadow 0.2s ease-out;
        width: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__radio_group__label:hover:before {
        box-shadow: 0 0 0 var(--adyen-sdk-spacer-010, 2px)
            var(--adyen-sdk-color-outline-primary-hover, #c9cdd3);
        cursor: pointer;
    }
    .adyen-checkout__radio_group__label:after {
        background-color: var(--adyen-sdk-color-background-primary, #ffffff);
        border-radius: 50%;
        box-shadow: 0 1px 1px rgba(0, 15, 45, 0.25);
        content: '';
        display: block;
        height: var(--adyen-sdk-spacer-030, 6px);
        left: 5px;
        margin: 0 auto;
        position: absolute;
        top: 7px;
        transform: scale(0);
        transition: transform 0.2s ease-out;
        width: var(--adyen-sdk-spacer-030, 6px);
    }
    .adyen-checkout__radio_group__label:hover {
        border-color: var(--adyen-sdk-color-label-primary, #00112c);
        cursor: pointer;
    }
    .adyen-checkout__radio_group__input:checked + .adyen-checkout__radio_group__label:before,
    .adyen-checkout__radio_group__label--selected {
        background-color: var(--adyen-sdk-color-label-primary, #00112c);
        border: 0;
        transition: all 0.2s ease-out;
    }
    .adyen-checkout__radio_group__input:checked + .adyen-checkout__radio_group__label:after {
        transform: scale(1);
    }
    .adyen-checkout__radio_group__input:focus + .adyen-checkout__radio_group__label:before {
        border-color: var(--adyen-sdk-color-label-primary, #00112c);
    }
    .adyen-checkout__radio_group__input:checked + .adyen-checkout__radio_group__label:hover:before,
    .adyen-checkout__radio_group__input:checked:active + .adyen-checkout__radio_group__label:before,
    .adyen-checkout__radio_group__input:checked:focus + .adyen-checkout__radio_group__label:before,
    .adyen-checkout__radio_group__input:focus + .adyen-checkout__radio_group__label:before {
        box-shadow: 0 0 0 var(--adyen-sdk-spacer-010, 2px)
            var(--adyen-sdk-color-outline-tertiary, #8d95a3);
    }
    .adyen-checkout__radio_group__label.adyen-checkout__radio_group__label--invalid:before {
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-critical, #e22d2d);
    }
    .adyen-checkout__radio_group--button {
        align-items: flex-start;
        align-self: stretch;
        display: flex;
        flex-wrap: wrap;
        gap: var(--adyen-sdk-spacer-070, 16px);
        width: 100%;
    }
    .adyen-checkout__radio_group--button .adyen-checkout__radio_group__input-wrapper {
        display: flex;
        flex: 1 0 0;
    }
    .adyen-checkout__radio_group--button .adyen-checkout__radio_group__label:after {
        left: calc(var(--adyen-sdk-spacer-060, 12px) + 5px);
        position: absolute;
        top: calc(50% - var(--adyen-sdk-spacer-030, 6px) / 2);
    }
    .adyen-checkout__radio_group--button .adyen-checkout__radio_group__label:before {
        left: calc(var(--adyen-sdk-spacer-060, 12px));
        position: absolute;
        top: calc(50% - var(--adyen-sdk-spacer-070, 16px) / 2);
    }
    .adyen-checkout__radio_group--button .adyen-checkout__radio_group__label {
        background-color: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-primary, #dbdee2);
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        padding: var(--adyen-sdk-spacer-060, 12px);
        padding-left: calc(var(--adyen-sdk-spacer-060, 12px) + var(--adyen-sdk-spacer-090, 24px));
        width: 100%;
    }
    .adyen-checkout__radio_group--button
        .adyen-checkout__radio_group__input
        + .adyen-checkout__radio_group__label:hover,
    .adyen-checkout__radio_group--button
        .adyen-checkout__radio_group__input:checked
        + .adyen-checkout__radio_group__label {
        border-color: var(--adyen-sdk-color-outline-primary-active, #00112c);
    }
    .adyen-checkout__radio_group--button
        .adyen-checkout__radio_group__input:checked:active
        + .adyen-checkout__radio_group__label,
    .adyen-checkout__radio_group--button
        .adyen-checkout__radio_group__input:checked:focus
        + .adyen-checkout__radio_group__label {
        border-color: var(--adyen-sdk-color-outline-primary-active, #00112c);
        box-shadow: 0 0 0 0.5px var(--adyen-sdk-color-outline-primary-active, #00112c);
    }
    .adyen-checkout__image {
        opacity: 0;
        transition: opacity 0.6s ease-out;
    }
    .adyen-checkout__image--loaded {
        opacity: 1;
    }
    .adyen-checkout__dropdown__button-icon--left {
        flex-direction: row-reverse;
        justify-content: flex-end;
    }
    .adyen-checkout__dropdown__button-icon--left > img {
        margin-left: 0;
        margin-right: var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout__dropdown {
        max-width: 100%;
        position: relative;
    }
    .adyen-checkout__dropdown,
    .adyen-checkout__dropdown__button {
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        width: 100%;
    }
    .adyen-checkout__dropdown__button {
        align-items: center;
        background: inherit;
        border-radius: inherit;
        color: var(--adyen-sdk-color-label-primary, #00112c);
        cursor: pointer;
        display: flex;
        height: var(--adyen-sdk-spacer-110, 40px);
        line-height: var(--adyen-sdk-text-body-line-height, 20px);
        outline: 0;
        padding: 0 var(--adyen-sdk-spacer-060, 12px);
        text-decoration: none;
        transition: border 0.2s ease-out, box-shadow 0.2s ease-out;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }
    [dir='rtl'] .adyen-checkout__dropdown__button {
        padding: 7px var(--adyen-sdk-spacer-060, 12px) 7px var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen-checkout__dropdown__button:after {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' fill='none' viewBox='0 0 16 17'%3E%3Cpath fill='%2300112C' fill-rule='evenodd' d='M4.47 6.47a.75.75 0 0 1 1.06 0L8 8.94l2.47-2.47a.75.75 0 0 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E");
        background-position: 50%;
        background-repeat: no-repeat;
        content: '';
        height: var(--adyen-sdk-spacer-030, 6px);
        position: absolute;
        right: var(--adyen-sdk-spacer-070, 16px);
        width: var(--adyen-sdk-spacer-040, 8px);
    }
    [dir='rtl'] .adyen-checkout__dropdown__button:after {
        left: var(--adyen-sdk-spacer-070, 16px);
        right: auto;
    }
    .adyen-checkout__dropdown__button--active:after {
        transform: rotate(180deg);
    }
    .adyen-checkout__dropdown__button--disabled {
        opacity: 0.4;
    }
    .adyen-checkout__dropdown__button--readonly,
    .adyen-checkout__dropdown__button--readonly--active,
    .adyen-checkout__dropdown__button--readonly:focus,
    .adyen-checkout__dropdown__button--readonly:hover {
        background: var(--adyen-sdk-color-background-disabled, #eeeff1);
        border-color: transparent;
        color: var(--adyen-sdk-color-label-primary, #00112c);
        cursor: not-allowed;
    }
    .adyen-checkout__dropdown__button--readonly:after {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='7' fill='none' viewBox='0 0 8 7'%3E%3Cpath fill='%23B9C4C9' d='M3.195 6.565a1 1 0 0 0 1.6 0l2.992-3.98a1 1 0 0 0-.8-1.602H1.013a1 1 0 0 0-.8 1.6z'/%3E%3C/svg%3E");
    }
    .adyen-checkout__dropdown__button--invalid {
        border-color: var(--adyen-sdk-color-outline-critical, #e22d2d);
    }
    .adyen-checkout__dropdown__button__icon {
        border-radius: 3px;
        height: 26px;
        margin-right: var(--adyen-sdk-spacer-060, 12px);
        max-width: var(--adyen-sdk-spacer-110, 40px);
    }
    .adyen-checkout__dropdown__button__text {
        flex-grow: 1;
        overflow: hidden;
        pointer-events: none;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .adyen-checkout__dropdown__button__text-placeholder {
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
    }
    .adyen-checkout__dropdown__button__secondary-text {
        margin-right: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__filter-input {
        background: inherit;
        border: 0;
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-family: inherit;
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        height: 100%;
        padding: 0;
        width: 100%;
    }
    .adyen-checkout__filter-input:active,
    .adyen-checkout__filter-input:focus {
        outline: 0;
    }
    .adyen-checkout__filter-input[readonly] {
        border-color: transparent;
        color: var(--adyen-sdk-color-label-secondary, #5c687c) !important;
        cursor: not-allowed;
    }
    .adyen-checkout__dropdown__list {
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        box-shadow: 0 var(--adyen-sdk-spacer-010, 2px) 7px rgba(0, 15, 45, 0.3);
        display: none;
        list-style: none;
        margin: 0 0 var(--adyen-sdk-spacer-120, 48px);
        max-height: 375px;
        overflow-y: auto;
        padding: 0;
        position: absolute;
        width: 100%;
        z-index: 2;
    }
    .adyen-checkout__dropdown__list.adyen-checkout__dropdown__list--active {
        display: block;
        margin-top: var(--adyen-sdk-spacer-010, 2px);
    }
    .adyen-checkout__dropdown__element {
        align-items: center;
        border: var(--adyen-sdk-border-width-s, 1px) solid transparent;
        cursor: pointer;
        display: flex;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        -webkit-hyphens: auto;
        hyphens: auto;
        line-height: var(--adyen-sdk-text-body-line-height, 20px);
        outline: 0;
        padding: var(--adyen-sdk-spacer-040, 8px);
        transition: background 0.2s ease-out, border-color 0.2s ease-out;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        word-break: break-word;
    }
    .adyen-checkout__dropdown__element .adyen-checkout__icon {
        position: absolute;
        right: var(--adyen-sdk-spacer-040, 8px);
    }
    .adyen-checkout__dropdown__element:last-child {
        border-bottom: 0;
    }
    .adyen-checkout__dropdown__element.adyen-checkout__dropdown__element--active {
        background: rgba(230, 233, 235, 0.6);
    }
    .adyen-checkout__dropdown__element.adyen-checkout__dropdown__element--selected {
        background: rgba(0, 102, 255, 0.1);
    }
    .adyen-checkout__dropdown__element.adyen-checkout__dropdown__element--selected:active,
    .adyen-checkout__dropdown__element.adyen-checkout__dropdown__element--selected:focus,
    .adyen-checkout__dropdown__element.adyen-checkout__dropdown__element--selected:hover {
        background: rgba(0, 102, 255, 0.15);
    }
    .adyen-checkout__dropdown__element--disabled {
        cursor: not-allowed;
        opacity: 0.4;
    }
    .adyen-checkout__dropdown__element__icon {
        border-radius: var(--adyen-sdk-border-radius-s, 4px);
        margin-right: var(--adyen-sdk-spacer-060, 12px);
        max-height: 26px;
        max-width: var(--adyen-sdk-spacer-110, 40px);
    }
    .adyen-checkout__dropdown__element__text {
        flex-grow: 1;
    }
    .adyen-checkout__dropdown__element__secondary-text:not(:last-child) {
        margin-right: var(--adyen-sdk-spacer-040, 8px);
    }
    .adyen-checkout__dropdown__element__flag {
        margin-left: var(--adyen-sdk-spacer-040, 8px);
        margin-right: var(--adyen-sdk-spacer-050, 10px);
        max-height: 18px;
        max-width: 27px;
    }
    .adyen-checkout__dropdown + .adyen-checkout-input__inline-validation {
        right: var(--adyen-sdk-spacer-100, 32px);
    }
    .adyen-checkout__installments .adyen-checkout__input-wrapper {
        background-color: transparent;
        border: none;
        box-shadow: none;
    }
    .adyen-checkout__installments .adyen-checkout__input-wrapper:active,
    .adyen-checkout__installments .adyen-checkout__input-wrapper:active:hover,
    .adyen-checkout__installments .adyen-checkout__input-wrapper:focus-within,
    .adyen-checkout__installments .adyen-checkout__input-wrapper:focus-within:hover {
        box-shadow: none;
    }
    .adyen-checkout__installments .adyen-checkout__fieldset--revolving-plan {
        margin-top: -5px;
    }
    .adyen-checkout-disclaimer__label {
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
        display: inline-block;
        font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
        font-weight: 400;
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin-top: var(--adyen-sdk-spacer-070, 16px);
        padding-left: 0;
    }
    [dir='rtl'] .adyen-checkout-disclaimer__label {
        padding-right: 0;
    }
    .adyen-checkout__card__dual-branding__buttons {
        display: flex;
        opacity: 0.4;
        pointer-events: none;
    }
    .adyen-checkout__card__dual-branding__buttons--active {
        opacity: 1;
        pointer-events: auto;
    }
    .adyen-checkout__card__dual-branding__buttons .adyen-checkout__card__cardNumber__brandIcon {
        cursor: pointer;
        opacity: 1;
    }
    .adyen-checkout__card__dual-branding__buttons
        .adyen-checkout__card__cardNumber__brandIcon:first-of-type {
        right: var(--adyen-sdk-spacer-110, 40px);
    }
    .adyen-checkout__card__dual-branding__buttons
        .adyen-checkout__card__cardNumber__brandIcon--not-selected {
        opacity: 0.5;
    }
    .adyen-checkout__card__brands {
        display: flex;
        flex-basis: auto;
        flex-shrink: 1;
        flex-wrap: wrap;
        margin-bottom: var(--adyen-sdk-spacer-060, 12px);
        margin-top: -12px;
        min-height: var(--adyen-sdk-spacer-090, 24px);
        transition: all 0.3s ease-out;
    }
    .adyen-checkout__card__brands__brand-wrapper {
        border-radius: var(--adyen-sdk-border-radius-s, 4px);
        box-shadow: var(
            --adyen-sdk-shadow-low,
            0 2px 4px rgba(0, 17, 44, 0.04),
            0 1px 2px rgba(0, 17, 44, 0.02)
        );
        display: inline-block;
        height: var(--adyen-sdk-spacer-070, 16px);
        margin: var(--adyen-sdk-spacer-020, 4px) var(--adyen-sdk-spacer-010, 2px);
        overflow: hidden;
        position: relative;
        width: var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen-checkout__card__brands--hidden {
        margin: -8px 0 8px;
        max-height: 0;
        min-height: 0;
        opacity: 0;
    }
    .adyen-checkout__card__brands img {
        display: block;
        height: auto;
        margin: 0;
        padding: 0;
        width: 100%;
    }
    .adyen-checkout__checkbox {
        display: flex;
        width: 100%;
    }
    .adyen-checkout__checkbox__label {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        cursor: pointer;
        display: inline-block;
        flex: 1;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: 400;
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        padding-left: var(--adyen-sdk-spacer-090, 24px);
        position: relative;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }
    [dir='rtl'] .adyen-checkout__checkbox__label {
        padding-left: 0;
        padding-right: var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen-checkout__checkbox__input {
        opacity: 0;
        pointer-events: none;
        position: absolute;
    }
    .adyen-checkout__checkbox__input:checked + .adyen-checkout__checkbox__label:before {
        opacity: 1;
    }
    .adyen-checkout__checkbox__input:checked + .adyen-checkout__checkbox__label:after {
        background-color: var(--adyen-sdk-color-label-primary, #00112c);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-label-primary, #00112c);
    }
    .adyen-checkout__checkbox__input:checked:hover + .adyen-checkout__checkbox__label:after {
        border-color: var(--adyen-sdk-color-label-primary, #00112c);
        box-shadow: 0 0 0 var(--adyen-sdk-spacer-010, 2px)
            var(--adyen-sdk-color-outline-tertiary, #8d95a3);
    }
    .adyen-checkout__checkbox__input:focus + .adyen-checkout__checkbox__label:after {
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-label-primary, #00112c);
        box-shadow: 0 0 0 var(--adyen-sdk-spacer-010, 2px)
            var(--adyen-sdk-color-outline-tertiary, #8d95a3);
    }
    .adyen-checkout__checkbox__input:hover:not(:focus) + .adyen-checkout__checkbox__label:after {
        border-color: var(--adyen-sdk-color-outline-tertiary, #8d95a3);
        box-shadow: 0 0 0 var(--adyen-sdk-spacer-010, 2px)
            var(--adyen-sdk-color-outline-primary-hover, #c9cdd3);
    }
    .adyen-checkout__checkbox__input + .adyen-checkout__checkbox__label:before {
        border-bottom: var(--adyen-sdk-spacer-010, 2px) solid
            var(--adyen-sdk-color-label-on-color, #ffffff);
        border-left: 1px solid transparent;
        border-radius: 0 var(--adyen-sdk-spacer-010, 2px) 1px;
        border-right: var(--adyen-sdk-spacer-010, 2px) solid
            var(--adyen-sdk-color-label-on-color, #ffffff);
        border-top: 1px solid transparent;
        content: '';
        height: 11px;
        left: 1px;
        opacity: 0;
        position: absolute;
        top: var(--adyen-sdk-spacer-010, 2px);
        transform: rotate(37deg);
        transform-origin: 100% 100%;
        transition: opacity 0.2s ease-out;
        width: var(--adyen-sdk-spacer-030, 6px);
        z-index: 1;
    }
    [dir='rtl'] .adyen-checkout__checkbox__input + .adyen-checkout__checkbox__label:before {
        left: auto;
        right: var(--adyen-sdk-spacer-040, 8px);
    }
    .adyen-checkout__checkbox__input + .adyen-checkout__checkbox__label:after {
        background-color: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-primary, #dbdee2);
        border-radius: var(--adyen-sdk-border-radius-s, 4px);
        content: '';
        height: var(--adyen-sdk-spacer-070, 16px);
        left: 0;
        position: absolute;
        top: 0;
        transition: background 0.15s ease-out, border 0.05s ease-out, box-shadow 0.1s ease-out;
        width: var(--adyen-sdk-spacer-070, 16px);
        z-index: 0;
    }
    [dir='rtl'] .adyen-checkout__checkbox__input + .adyen-checkout__checkbox__label:after {
        left: auto;
        right: 0;
    }
    .adyen-checkout__field--consentCheckbox {
        align-items: center;
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-primary, #dbdee2);
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        display: flex;
    }
    .adyen-checkout__field--consentCheckbox,
    [dir='rtl'] .adyen-checkout__field--consentCheckbox {
        padding: var(--adyen-sdk-spacer-060, 12px) var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__field--consentCheckbox .adyen-checkout__input-wrapper {
        background-color: transparent;
        border: none;
        box-shadow: none;
        flex: 1;
        justify-content: space-between;
    }
    .adyen-checkout__field--consentCheckbox .adyen-checkout__input-wrapper:active,
    .adyen-checkout__field--consentCheckbox .adyen-checkout__input-wrapper:active:hover,
    .adyen-checkout__field--consentCheckbox .adyen-checkout__input-wrapper:focus-within,
    .adyen-checkout__field--consentCheckbox .adyen-checkout__input-wrapper:focus-within:hover {
        box-shadow: none;
    }
    .adyen-checkout__field--consentCheckbox.adyen-checkout__field--error {
        border-color: var(--adyen-sdk-color-outline-critical, #e22d2d);
    }
    .adyen-checkout__field--consentCheckbox .adyen-checkout-input__inline-validation {
        margin-right: 0;
    }
    [dir='rtl'] .adyen-checkout__field--consentCheckbox .adyen-checkout-input__inline-validation {
        margin-left: 0;
    }
    .adyen-checkout__store-details {
        align-items: center;
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-primary, #dbdee2);
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        display: flex;
        gap: var(--adyen-sdk-spacer-060, 12px);
        margin-top: var(--adyen-sdk-spacer-070, 16px);
        padding: var(--adyen-sdk-spacer-060, 12px) var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__address-search {
        position: relative;
    }
    .adyen-checkout__address-search .adyen-checkout__dropdown__button:after {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='%23687282' d='M6.5 11.9a4.5 4.5 0 0 0 2.6-.83l2.77 2.74c.13.13.3.19.48.19.38 0 .65-.29.65-.66a.63.63 0 0 0-.19-.46l-2.75-2.73a4.4 4.4 0 0 0 .92-2.7 4.48 4.48 0 0 0-8.98 0 4.48 4.48 0 0 0 4.5 4.45m0-.96a3.53 3.53 0 0 1-3.53-3.49 3.52 3.52 0 0 1 7.04 0c0 1.9-1.59 3.49-3.52 3.49Z'/%3E%3C/svg%3E");
        background-position: 50%;
        background-repeat: no-repeat;
        content: '';
        height: var(--adyen-sdk-spacer-070, 16px);
        left: var(--adyen-sdk-spacer-060, 12px);
        position: absolute;
        width: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__address-search .adyen-checkout__dropdown__button--active:after {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='%2300112C' d='M6.5 11.9a4.5 4.5 0 0 0 2.6-.83l2.77 2.74c.13.13.3.19.48.19.38 0 .65-.29.65-.66a.63.63 0 0 0-.19-.46l-2.75-2.73a4.4 4.4 0 0 0 .92-2.7 4.48 4.48 0 0 0-8.98 0 4.48 4.48 0 0 0 4.5 4.45m0-.96a3.53 3.53 0 0 1-3.53-3.49 3.52 3.52 0 0 1 7.04 0c0 1.9-1.59 3.49-3.52 3.49Z'/%3E%3C/svg%3E");
        transform: none;
    }
    .adyen-checkout__address-search .adyen-checkout__filter-input {
        padding-left: calc(var(--adyen-sdk-spacer-040, 8px) + var(--adyen-sdk-spacer-070, 16px));
        position: relative;
    }
    .adyen-checkout__address-search__manual-add {
        position: absolute;
        right: 0;
        top: 0;
    }
    .adyen-checkout__address-search__manual-add
        .adyen-checkout__address-search__manual-add__button {
        border: 0;
        padding: 0;
    }
    .adyen-checkout-form-instruction {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
        margin-top: 0;
    }
    [dir='rtl'] .adyen-checkout-form-instruction {
        padding-right: 0;
    }
    .adyen-checkout__button {
        background: var(--adyen-sdk-color-background-always-dark, #00112c);
        border: 0;
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        color: var(--adyen-sdk-color-label-on-color, #ffffff);
        cursor: pointer;
        font-size: var(--adyen-sdk-text-title-font-size, 1rem);
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
        height: var(--adyen-sdk-spacer-120, 48px);
        margin: 0;
        padding: var(--adyen-sdk-spacer-060, 12px) var(--adyen-sdk-spacer-000, 0);
        text-decoration: none;
        transition: background 0.3s ease-out, box-shadow 0.3s ease-out;
        width: 100%;
    }
    .adyen-checkout__button:focus {
        box-shadow: 0 0 0 1px var(--adyen-sdk-color-outline-tertiary, #8d95a3);
        outline: 0;
    }
    .adyen-checkout__button:hover {
        background: var(--adyen-sdk-color-background-inverse-primary-hover, #5c687c);
        box-shadow: 0 0,
            0 var(--adyen-sdk-spacer-010, 2px) var(--adyen-sdk-spacer-020, 4px) -1px rgba(0, 0, 0, 0.2),
            0 var(--adyen-sdk-spacer-020, 4px) 5px 0 rgba(0, 0, 0, 0.14);
    }
    .adyen-checkout__button:active {
        background: var(--adyen-sdk-color-background-always-dark-active, #8d95a3);
    }
    .adyen-checkout__button:hover:focus {
        box-shadow: 0 0 0 var(--adyen-sdk-spacer-010, 2px)
                var(--adyen-sdk-color-outline-tertiary, #8d95a3),
            0 3px var(--adyen-sdk-spacer-020, 4px) rgba(0, 15, 45, 0.2);
    }
    .adyen-checkout__button:disabled,
    .adyen-checkout__button:disabled:hover {
        box-shadow: none;
        cursor: not-allowed;
        opacity: 0.4;
        -webkit-user-select: all;
        -moz-user-select: all;
        user-select: all;
    }
    .adyen-checkout__button.adyen-checkout__button--loading {
        background: var(--adyen-sdk-color-label-disabled, #8d95a3);
        box-shadow: none;
        pointer-events: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }
    .adyen-checkout__button.adyen-checkout__button--pay {
        display: flex;
        justify-content: center;
        margin-top: var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen-checkout__button.adyen-checkout__button--pay:disabled {
        opacity: 0.4;
    }
    .adyen-checkout__button.adyen-checkout__button--standalone {
        margin-top: 0;
    }
    .adyen-checkout__button.adyen-checkout__button--inline {
        display: block;
        font-size: 0.81em;
        height: auto;
        padding: var(--adyen-sdk-spacer-050, 10px) var(--adyen-sdk-spacer-040, 8px);
        width: auto;
    }
    .adyen-checkout__button.adyen-checkout__button--ghost {
        background: none;
        border: 0;
        color: var(--adyen-sdk-color-label-primary, #00112c);
    }
    .adyen-checkout__button.adyen-checkout__button--ghost .adyen-checkout__spinner:before {
        border-color: var(--adyen-sdk-color-background-inverse-primary, #00112c);
        border-top-color: transparent;
        opacity: 0.1;
    }
    .adyen-checkout__button.adyen-checkout__button--ghost .adyen-checkout__spinner:after {
        border-color: transparent;
        border-top-color: var(--adyen-sdk-color-outline-primary-active, #00112c);
    }
    .adyen-checkout__button.adyen-checkout__button--ghost:hover {
        background: var(--adyen-sdk-color-background-secondary-hover, #eeeff1);
        box-shadow: none;
    }
    .adyen-checkout__button.adyen-checkout__button--ghost:active {
        background: var(--adyen-sdk-color-background-secondary-active, #e3e5e9);
        box-shadow: none;
    }
    .adyen-checkout__button.adyen-checkout__button--secondary {
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-label-primary, #00112c);
        color: var(--adyen-sdk-color-label-primary, #00112c);
        padding: var(--adyen-sdk-spacer-050, 10px) var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout__button.adyen-checkout__button--secondary .adyen-checkout__spinner:before {
        border-color: var(--adyen-sdk-color-background-inverse-primary, #00112c);
        border-top-color: transparent;
        opacity: 0.1;
    }
    .adyen-checkout__button.adyen-checkout__button--secondary .adyen-checkout__spinner:after {
        border-color: transparent;
        border-top-color: var(--adyen-sdk-color-outline-primary-active, #00112c);
    }
    .adyen-checkout__button.adyen-checkout__button--secondary:hover {
        background: var(--adyen-sdk-color-background-secondary, #f7f7f8);
        box-shadow: 0 var(--adyen-sdk-spacer-010, 2px) var(--adyen-sdk-spacer-020, 4px)
                rgba(27, 42, 60, 0.2),
            0 var(--adyen-sdk-spacer-020, 4px) 5px rgba(27, 42, 60, 0.14);
    }
    .adyen-checkout__button.adyen-checkout__button--secondary:active,
    .adyen-checkout__button.adyen-checkout__button--secondary:active:hover {
        background: var(--adyen-sdk-color-background-secondary, #f7f7f8);
        box-shadow: none;
    }
    .adyen-checkout__button.adyen-checkout__button--secondary:focus {
        box-shadow: 0 0 0 0.5px var(--adyen-sdk-color-outline-tertiary, #8d95a3);
        outline: 0;
    }
    .adyen-checkout__button.adyen-checkout__button--secondary:disabled,
    .adyen-checkout__button.adyen-checkout__button--secondary:disabled:hover {
        background-color: var(--adyen-sdk-color-background-secondary, #f7f7f8);
        border-color: var(--adyen-sdk-color-outline-disabled, #dbdee2);
        box-shadow: none;
        cursor: not-allowed;
        opacity: 0.5;
        -webkit-user-select: all;
        -moz-user-select: all;
        user-select: all;
    }
    .adyen-checkout__button.adyen-checkout__button--action {
        background: var(--adyen-sdk-color-background-always-dark, #00112c);
        border: var(--adyen-sdk-border-width-s, 1px) solid transparent;
        color: var(--adyen-sdk-color-label-on-color, #ffffff);
        padding: var(--adyen-sdk-spacer-050, 10px) var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout__button.adyen-checkout__button--action:hover {
        background: var(--adyen-sdk-color-background-inverse-primary-hover, #5c687c);
        box-shadow: none;
    }
    .adyen-checkout__button.adyen-checkout__button--action:active,
    .adyen-checkout__button.adyen-checkout__button--action:active:hover {
        background: var(--adyen-sdk-color-background-always-dark-active, #8d95a3);
        box-shadow: none;
    }
    .adyen-checkout__button.adyen-checkout__button--link {
        background: transparent;
        border: var(--adyen-sdk-border-width-s, 1px) solid transparent;
        border-radius: var(--adyen-sdk-border-radius-s, 4px);
        color: var(--adyen-sdk-color-label-highlight, #0070f5);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        padding: var(--adyen-sdk-spacer-010, 2px);
        text-decoration: none;
    }
    .adyen-checkout__button.adyen-checkout__button--link:hover {
        background: transparent;
        box-shadow: none;
        text-decoration: underline;
    }
    .adyen-checkout__button.adyen-checkout__button--completed,
    .adyen-checkout__button.adyen-checkout__button--completed:active,
    .adyen-checkout__button.adyen-checkout__button--completed:active:hover,
    .adyen-checkout__button.adyen-checkout__button--completed:hover {
        background: var(--adyen-sdk-color-label-success, #07893c);
        color: var(--adyen-sdk-color-label-on-color, #ffffff);
    }
    .adyen-checkout__button.adyen-checkout__button--completed .adyen-checkout__button__icon {
        filter: brightness(0) invert(1);
    }
    .adyen-checkout__button__content {
        align-items: center;
        display: flex;
        height: 100%;
        justify-content: center;
    }
    .adyen-checkout__button__icon {
        margin-right: var(--adyen-sdk-spacer-040, 8px);
    }
    [dir='rtl'] .adyen-checkout__button__icon {
        margin-left: var(--adyen-sdk-spacer-040, 8px);
        margin-right: 0;
    }
    .adyen-checkout__button__text {
        display: block;
        justify-content: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .adyen-checkout__button__text--sr-only {
        border: 0;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
    }
    .adyen-checkout__button .adyen-checkout__spinner:before {
        border-color: var(--adyen-sdk-color-label-on-color, #ffffff);
        border-top-color: transparent;
        opacity: 0.1;
    }
    .adyen-checkout__button .adyen-checkout__spinner:after {
        border-color: transparent;
        border-top-color: var(--adyen-sdk-color-label-on-color, #ffffff);
    }
    .adyen-checkout-ctp__otp-resend-code-wrapper {
        line-height: var(--adyen-sdk-text-body-line-height, 20px);
        margin-left: auto;
        position: absolute;
        right: 0;
        top: 0;
    }
    .adyen-checkout-ctp__otp-resend-code--confirmation,
    .adyen-checkout-ctp__otp-resend-code--disabled {
        color: var(--adyen-sdk-color-label-tertiary, #5c687c);
        cursor: default;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        margin-left: auto;
        pointer-events: none;
    }
    .adyen-checkout-ctp__otp-resend-code--confirmation {
        align-items: center;
        display: flex;
    }
    .adyen-checkout-ctp__otp-resend-code--confirmation > img {
        margin-left: var(--adyen-sdk-spacer-020, 4px);
    }
    .adyen-checkout-ctp__otp-resend-code-counter {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        cursor: default;
        display: inline-block;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        margin-left: auto;
        text-align: right;
    }
    .adyen-checkout-ctp__section > .adyen-checkout__field.adyen-checkout__field--otp {
        margin-bottom: var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout-ctp__otp-field-wrapper {
        position: relative;
    }
    .adyen_checkout-ctp__brand-wrapper {
        align-items: center;
        display: flex;
        height: 18px;
    }
    .adyen_checkout-ctp__brand-logo {
        margin-right: var(--adyen-sdk-spacer-030, 6px);
        width: var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen_checkout-ctp__brand-pipe {
        height: 15px;
        margin-right: var(--adyen-sdk-spacer-030, 6px);
    }
    .adyen_checkout-ctp__brand-scheme {
        margin-right: var(--adyen-sdk-spacer-030, 6px);
        -o-object-fit: none;
        object-fit: none;
    }
    .adyen_checkout-ctp__brand-scheme-mc {
        width: 27px;
    }
    .adyen_checkout-ctp__brand-scheme-visa {
        width: 35px;
    }
    .adyen-checkout__modal-wrapper {
        align-items: center;
        display: flex;
        height: 100%;
        left: 0;
        overflow-y: auto;
        overscroll-behavior-y: contain;
        padding: var(--adyen-sdk-spacer-090, 24px);
        position: fixed;
        top: 0;
        visibility: hidden;
        width: 100%;
        z-index: 10;
    }
    .adyen-checkout__modal-wrapper:before {
        background: rgba(0, 17, 44, 0.5);
        content: '';
        height: 100%;
        left: 0;
        opacity: 0;
        position: fixed;
        top: 0;
        transition: opacity 0.3s linear;
        width: 100%;
        z-index: 10;
    }
    .adyen-checkout__modal-wrapper--open {
        visibility: visible;
    }
    .adyen-checkout__modal-wrapper--open .adyen-checkout__modal,
    .adyen-checkout__modal-wrapper--open:before {
        opacity: 1;
    }
    .adyen-checkout__modal {
        background-color: var(--adyen-sdk-color-background-primary, #ffffff);
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        box-shadow: 0 var(--adyen-sdk-spacer-040, 8px) var(--adyen-sdk-spacer-090, 24px)
            rgba(0, 17, 44, 0.15);
        margin: auto;
        opacity: 0;
        padding: var(--adyen-sdk-spacer-070, 16px);
        position: relative;
        transition: opacity 0.2s ease, visibility 0.2s ease;
        z-index: 11;
    }
    @media (max-width: 480px) {
        .adyen-checkout__modal-wrapper {
            padding: 0;
        }
        .adyen-checkout__modal {
            border-radius: 0;
            height: 100%;
        }
    }
    .adyen-checkout__ctp-modal-header-image {
        display: block;
        margin: auto;
    }
    .adyen-checkout__ctp-modal-title {
        font-size: var(--adyen-sdk-text-title-m-font-size, 1.25rem);
        font-weight: 700;
        line-height: var(--adyen-sdk-spacer-090, 24px);
        margin: 0 0 var(--adyen-sdk-spacer-060, 12px);
        padding: 0;
    }
    .adyen-checkout__ctp-modal-text {
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__ctp-modal-benefits {
        margin-left: 0;
        padding-left: var(--adyen-sdk-spacer-080, 20px);
    }
    .adyen-checkout__ctp-modal-benefits li {
        list-style: disc;
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__modal-wrapper--ctp .adyen-checkout__modal {
        max-width: 464px;
    }
    .adyen_checkout-ctp__brand-wrapper--popup {
        justify-content: center;
        margin-bottom: var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen-web__ctp-info-button {
        background-color: transparent;
        border: 0;
        cursor: pointer;
        padding: 0;
    }
    .adyen-checkout__button--section-logout-button {
        margin-left: auto;
    }
    .adyen-checkout__button--section-logout-button--disabled {
        color: var(--adyen-sdk-color-label-disabled, #8d95a3);
        pointer-events: none;
    }
    .adyen-checkout-ctp__section {
        background-color: white;
        border-radius: var(--adyen-sdk-spacer-060, 12px);
        box-shadow: 0 6px 12px rgba(0, 17, 44, 0.08), 0 2px 4px rgba(0, 17, 44, 0.04);
        padding: var(--adyen-sdk-spacer-070, 16px);
        position: relative;
    }
    .adyen-checkout-ctp__section-brand {
        align-items: center;
        display: flex;
        height: 18px;
        margin-bottom: 16px;
    }
    .adyen-checkout-ctp__section--standalone {
        all: unset;
    }
    .adyen-checkout-ctp__section .adyen-checkout__fieldset {
        margin-bottom: var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen-checkout-ctp__section-header {
        align-items: center;
        display: flex;
    }
    .adyen-checkout-ctp__section-header-title {
        font-size: var(--adyen-sdk-text-title-font-size, 1rem);
        font-weight: var(--adyen-sdk-text-title-font-weight, 600);
        line-height: 22px;
        margin: 0;
        padding: 0;
        width: auto;
    }
    @media screen and (max-width: 400px) {
        .adyen-checkout-ctp__section-header-title {
            font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        }
    }
    .adyen-checkout-ctp__section-header-adornment {
        margin-left: 5px;
    }
    .adyen-checkout-ctp__section-text {
        color: var(--adyen-sdk-color-label-tertiary, #5c687c);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin: 0 0 var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout-ctp__section-text,
    .adyen-checkout-ctp__separator {
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
    }
    .adyen-checkout-ctp__separator {
        color: var(--adyen-sdk-color-label-primary, #00112c);
    }
    .adyen-checkout-ctp__otp-subtitle--highlighted {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
    }
    .adyen-checkout-ctp__otp-checkbox-container {
        background-color: #f7f8f9;
        border-radius: var(--adyen-sdk-border-radius-s, 4px);
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
        padding: var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout-ctp__otp-checkbox-container--checked {
        background-color: #f2f8ff;
    }
    .adyen-checkout-ctp__otp-checkbox-container label {
        cursor: pointer;
    }
    .adyen-checkout-ctp__section .adyen-checkout__field.adyen-checkout-ctp__otp-checkbox-container {
        margin-bottom: var(--adyen-sdk-spacer-020, 4px);
    }
    .adyen-checkout-ctp__otp-checkbox-info {
        color: #707070;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        line-height: var(--adyen-sdk-text-body-line-height, 20px);
        margin: var(--adyen-sdk-spacer-020, 4px) 0 0;
    }
    .adyen-checkout-ctp__otp-readmore-button {
        all: unset;
        color: #0075ff;
        cursor: pointer;
        text-transform: lowercase;
    }
    .adyen-checkout-ctp__card-list-single-card {
        align-items: center;
        background-color: var(--adyen-sdk-color-background-secondary, #f7f7f8);
        border-radius: var(--adyen-sdk-spacer-030, 6px);
        display: flex;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        height: var(--adyen-sdk-spacer-110, 40px);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        padding: var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout-ctp__card-list-single-card-expired {
        color: var(--adyen-sdk-color-label-tertiary, #5c687c);
        text-decoration: line-through;
    }
    .adyen-checkout-ctp__expired-label {
        color: var(--adyen-sdk-color-label-tertiary, #5c687c);
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
        line-height: 17px;
        margin-left: auto;
    }
    .adyen-checkout-ctp__card-image {
        border-radius: 3px;
        height: 24px;
        margin-right: var(--adyen-sdk-spacer-040, 8px);
    }
    .checkout-secondary-button__text {
        font-size: 0.85em;
        margin-left: 5px;
        margin-top: 1px;
    }
    .adyen-checkout-ctp__cards-list-dropdown .adyen-checkout__dropdown__element--disabled {
        opacity: 1;
    }
    .adyen-checkout-ctp__cards-list-dropdown
        .adyen-checkout__dropdown__element--disabled
        .adyen-checkout__dropdown__element__text {
        margin: 0;
        opacity: 0.4;
        text-decoration: line-through;
    }
    .adyen-checkout-ctp__cards-list-dropdown
        .adyen-checkout__dropdown__element--disabled
        .adyen-checkout__dropdown__element__secondary-text {
        color: var(--adyen-sdk-color-label-tertiary, #5c687c);
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
        line-height: 17px;
    }
    .adyen-checkout-ctp__cards-list-dropdown .adyen-checkout__dropdown__button--disabled {
        opacity: 1;
    }
    .adyen-checkout-ctp__cards-list-dropdown
        .adyen-checkout__dropdown__button--disabled
        .adyen-checkout__dropdown__button__text {
        opacity: 0.4;
        text-decoration: line-through;
    }
    .adyen-checkout-ctp__cards-list-dropdown
        .adyen-checkout__dropdown__button--disabled
        .adyen-checkout__dropdown__button__secondary-text {
        color: var(--adyen-sdk-color-label-tertiary, #5c687c);
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
        opacity: 1;
    }
    .adyen-checkout__iframe {
        border: 0;
    }
    .adyen-checkout-ctp__card {
        background-color: white;
        border: none;
        border-radius: var(--adyen-sdk-spacer-020, 4px);
        box-shadow: 0 0 0 var(--adyen-sdk-spacer-010, 2px) #999595;
        cursor: pointer;
        height: var(--adyen-sdk-spacer-110, 40px);
        margin: 0;
        margin-bottom: var(--adyen-sdk-spacer-080, 20px);
        width: 100%;
    }
    .adyen-checkout-ctp__empty-cards {
        align-items: center;
        background-color: var(--adyen-sdk-color-background-secondary, #f7f7f8);
        border-radius: var(--adyen-sdk-spacer-030, 6px);
        color: var(--adyen-sdk-color-label-tertiary, #5c687c);
        display: flex;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        height: var(--adyen-sdk-spacer-110, 40px);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin-bottom: var(--adyen-sdk-spacer-090, 24px);
        padding: var(--adyen-sdk-spacer-060, 12px) var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__iframe--ctpIframe {
        pointer-events: auto;
    }
    .adyen-checkout__iframe--ctpIframe-hidden {
        display: none;
    }
    @keyframes card-bounce {
        0% {
            animation-timing-function: cubic-bezier(0.17, 0.17, 0.32, 1);
            -webkit-translate: 0 -60%;
            -moz-translate: 0 -60%;
            -ms-translate: 0 -60%;
            translate: 0 -60%;
        }
        9.70874% {
            animation-timing-function: cubic-bezier(0.41, 0, 0.49, 1);
            -webkit-translate: 0 8.5%;
            -moz-translate: 0 8.5%;
            -ms-translate: 0 8.5%;
            translate: 0 8.5%;
        }
        23.4466% {
            animation-timing-function: cubic-bezier(0.29, 0, 0.26, 1);
            -webkit-translate: 0 -22.5%;
            -moz-translate: 0 -22.5%;
            -ms-translate: 0 -22.5%;
            translate: 0 -22.5%;
        }
        47.7184% {
            -webkit-translate: 0;
            -moz-translate: 0;
            -ms-translate: 0;
            translate: 0;
        }
        63.8835% {
            animation-timing-function: cubic-bezier(1, 0, 0.78, 1);
            -webkit-translate: 0;
            -moz-translate: 0;
            -ms-translate: 0;
            translate: 0;
        }
        86.5534% {
            -webkit-translate: 0 40.7%;
            -moz-translate: 0 40.7%;
            -ms-translate: 0 40.7%;
            translate: 0 40.7%;
        }
        to {
            -webkit-translate: 0 40.7%;
            -moz-translate: 0 40.7%;
            -ms-translate: 0 40.7%;
            translate: 0 40.7%;
        }
    }
    @keyframes card-fade-100 {
        0% {
            animation-timing-function: linear;
            opacity: 0;
        }
        8.1068% {
            opacity: 1;
        }
        78.4466% {
            opacity: 1;
        }
        86.5534% {
            opacity: 0;
        }
        to {
            opacity: 0;
        }
    }
    @keyframes card-fade-60 {
        0% {
            animation-timing-function: linear;
            opacity: 0;
        }
        8.1068% {
            opacity: 0.6;
        }
        78.4466% {
            opacity: 0.6;
        }
        86.5534% {
            opacity: 0;
        }
        to {
            opacity: 0;
        }
    }
    @keyframes card-fade-20 {
        0% {
            animation-timing-function: linear;
            opacity: 0;
        }
        8.1068% {
            opacity: 0.2;
        }
        78.4466% {
            opacity: 0.2;
        }
        86.5534% {
            opacity: 0;
        }
        to {
            opacity: 0;
        }
    }
    .adyen-checkout-ctp__card-animation {
        aspect-ratio: 1/0.438;
        filter: grayscale(1);
        margin: 40px auto 50px;
        max-width: 100%;
        position: relative;
        width: 140px;
    }
    .adyen-checkout-ctp__card-animation > .adyen-checkout-ctp__card-animation-layer {
        background-size: contain !important;
        height: 100%;
        opacity: 0;
        position: absolute;
        width: 100%;
    }
    .adyen-checkout-ctp__card-animation > .adyen-checkout-ctp__card-animation-layer:first-of-type {
        animation: card-bounce 2.06s linear infinite both, card-fade-100 2.06s linear infinite both;
        animation-delay: 0.1s;
        background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1064' height='466' fill='none'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='m895.31 228.862-46.416-10.988c-1.172-.381-2.528-.481-3.565-.203-1.582.424-1.825 1.567-.543 2.554.676.52 1.641.893 2.634 1.067l42.816 10.545-.537 21.742-2.328.624-6.897 1.848 1.146-20.056q.002-.019.003-.037h.005c.061-.536-.274-1.054-.864-1.494-.563-.447-1.399-.831-2.462-1.065l-.003.001-.072-.016-46.587-10.849-.032-.008c-1.18-.39-2.554-.496-3.601-.215l-16.926 4.535c-1.582.424-1.825 1.568-.542 2.555.389.299.859.593 1.407.742l44.453 10.938-.526 19.429c-.021.101.234 2.007-2.662 2.783l-22.831 6.118c-3.105.832-7.644.01-10.253-1.998l-32.227-24.8c-2.271-1.748-2.029-4.233 1.146-5.083l14.204-3.806c1.674-.449 1.938-1.481.58-2.526s-3.556-1.501-5.23-1.053l-14.297 3.879c-6.795 1.82-6.817 6.539-2.199 10.093l32.275 24.837c4.972 3.826 14.615 5.636 20.567 4.042l22.824-6.116c1.151-.309 2.067-.696 2.797-1.118q.156-.091.301-.183c2.32-1.48 2.521-3.296 2.528-3.671l1.19-21.406c.081-.992-1.14-2.073-3.289-2.548l-.003.002-.072-.017-39.385-9.196 7.065-1.893 2.329-.624 41.998 10.256-.496 22.836q0 .01.093.032c.113.304.361.618.75.918 1.283.987 3.605 1.443 5.187 1.02l16.925-4.535c1.048-.281 1.507-.878 1.326-1.536l1.612-23.779.002-.037.005-.001c.123-1.083-1.369-2.092-3.323-2.539'/%3E%3Cpath stroke='%23fff' d='m895.31 228.862-46.416-10.988c-1.172-.381-2.528-.481-3.565-.203-1.582.424-1.825 1.567-.543 2.554.676.52 1.641.893 2.634 1.067l42.816 10.545-.537 21.742-2.328.624-6.897 1.848 1.146-20.056q.002-.019.003-.037h.005c.061-.536-.274-1.054-.864-1.494-.563-.447-1.399-.831-2.462-1.065l-.003.001-.072-.016-46.587-10.849-.032-.008c-1.18-.39-2.554-.496-3.601-.215l-16.926 4.535c-1.582.424-1.825 1.568-.542 2.555.389.299.859.593 1.407.742l44.453 10.938-.526 19.429c-.021.101.234 2.007-2.662 2.783l-22.831 6.118c-3.105.832-7.644.01-10.253-1.998l-32.227-24.8c-2.271-1.748-2.029-4.233 1.146-5.083l14.204-3.806c1.674-.449 1.938-1.481.58-2.526s-3.556-1.501-5.23-1.053l-14.297 3.879c-6.795 1.82-6.817 6.539-2.199 10.093l32.275 24.837c4.972 3.826 14.615 5.636 20.567 4.042l22.824-6.116c1.151-.309 2.067-.696 2.797-1.118q.156-.091.301-.183c2.32-1.48 2.521-3.296 2.528-3.671l1.19-21.406c.081-.992-1.14-2.073-3.289-2.548l-.003.002-.072-.017-39.385-9.196 7.065-1.893 2.329-.624 41.998 10.256-.496 22.836q0 .01.093.032c.113.304.361.618.75.918 1.283.987 3.605 1.443 5.187 1.02l16.925-4.535c1.048-.281 1.507-.878 1.326-1.536l1.612-23.779.002-.037.005-.001c.123-1.083-1.369-2.092-3.323-2.539'/%3E%3Cpath fill='%23fff' fill-opacity='.9' fill-rule='evenodd' d='M418.95 242.813c-1.166.08-3.042-.372-4.121-.994-.702-.405-.941-.755-1.527-2.243-2.373-6.017-6.517-11.028-13.679-16.54-6.921-5.325-13.863-9.053-24.178-12.987-2.215-.844-4.182-1.652-4.368-1.795-.687-.528-.979-1.482-.612-1.986.505-.691 2.349-1.081 3.824-.809.567.103 2.521.743 4.345 1.421 7.215 2.687 13.99 5.937 20.009 9.598 3.723 2.267 9.803 6.823 12.219 9.164 4.462 4.317 7.493 8.422 9.4 12.73 1.153 2.604 1.269 3.77.4 4.003a2.4 2.4 0 0 0-.548.23c-.132.08-.653.173-1.164.208m-16.069-.701c-1.791.122-4.29-.719-4.965-1.671-.163-.23-.697-1.349-1.19-2.485-2.083-4.815-6.346-9.43-12.427-13.455-4.994-3.305-8.797-5.218-15.392-7.737-4.424-1.69-4.929-2-5.087-3.117-.146-1.06 1.961-1.804 4.061-1.431 1.457.258 8.467 2.972 11.969 4.634 11.594 5.498 19.993 12.484 23.913 19.889 2.008 3.792 1.779 5.192-.882 5.373m-16.492-.659c-1.224-.015-2.768-.406-3.758-.951-.603-.332-.912-.797-1.614-2.437-2.575-6.024-8.768-10.833-18.898-14.676-4.447-1.688-5.038-2.104-4.718-3.324.158-.605.358-.757 1.34-1.02 1.642-.44 3.175-.146 7.121 1.365 6.068 2.325 10.298 4.621 14.525 7.881 4.345 3.352 6.465 5.882 8.069 9.62.915 2.141.839 2.79-.389 3.282-.375.149-1.131.266-1.678.26m-15.379-.611c-.949.006-2.546-.385-3.476-.851-1.035-.519-1.424-1.045-1.796-2.434-.477-1.786-1.147-2.632-3.558-4.488s-3.719-2.531-6.931-3.584c-1.089-.356-2.302-.809-2.698-1.003-1.658-.818-1.914-2.296-.508-2.936 1.187-.544 2.67-.406 5.617.522 8.533 2.685 14.934 7.611 15.941 12.27.357 1.645-.521 2.495-2.591 2.504'/%3E%3Crect width='110' height='74' fill='url(%23a)' rx='10' transform='matrix(.96593 -.25882 .7925 .60987 199.717 245.906)'/%3E%3Cg stroke='%23000' stroke-opacity='.8' stroke-width='2'%3E%3Cpath d='m233.447 236.868 46.846 36.05c.876.673.72 1.451-.347 1.737l-31.799 8.521M266.657 262.424l-33.731 9.038m17.126-21.816-33.73 9.038m115.215 13.423-46.846-36.05c-.875-.673-.72-1.451.347-1.737l31.799-8.52M298.327 246.551l33.731-9.038m-17.126 21.816 33.731-9.038'/%3E%3Crect width='112' height='76' x='-1.758' y='-.351' rx='11' style='mix-blend-mode:soft-light' transform='matrix(.96593 -.25882 .7925 .60987 199.935 245.314)'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='a' x1='-12.604' x2='99.193' y1='0' y2='88.114' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23fff'/%3E%3Cstop offset='.484' stop-color='%23b3b3b3'/%3E%3Cstop offset='1' stop-color='%23fff'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E")
                0 0 no-repeat,
            url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1064' height='466' fill='none'%3E%3Cg clip-path='url(%23a)'%3E%3Crect width='728' height='455' fill='url(%23b)' rx='24' transform='matrix(.96593 -.25882 .7925 .60987 0 188.42)'/%3E%3Cg fill='%23033783'%3E%3Cpath fill-opacity='.2' d='M638.209-50.009C376.564 99.506 477.408 320.518 560.535 412.335L1063.78 277.49z'/%3E%3Cpath fill-opacity='.4' d='M711.119 6.099C494.132 130.043 577.63 313.21 646.503 389.3l417.277-111.81z'/%3E%3C/g%3E%3Cpath fill='%23003780' d='M791.162 67.695C624.04 163.343 688.839 304.87 742.129 363.677l321.651-86.187z'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='b' x1='72.545' x2='249.224' y1='26.435' y2='498.002' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%233382ea'/%3E%3Cstop offset='1' stop-color='%23003ea9'/%3E%3C/linearGradient%3E%3CclipPath id='a'%3E%3Crect width='728' height='455' fill='%23fff' rx='24' transform='matrix(.96593 -.25882 .7925 .60987 0 188.42)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E")
                0 0 no-repeat;
        opacity: 1;
        z-index: 3;
    }
    .adyen-checkout-ctp__card-animation > .adyen-checkout-ctp__card-animation-layer:nth-of-type(2) {
        animation: card-bounce 2.06s linear infinite both, card-fade-60 2.06s linear infinite both;
        animation-delay: 50ms;
        opacity: 0.6;
        transform: translateY(25%);
        z-index: 2;
    }
    .adyen-checkout-ctp__card-animation > .adyen-checkout-ctp__card-animation-layer:nth-of-type(2),
    .adyen-checkout-ctp__card-animation > .adyen-checkout-ctp__card-animation-layer:nth-of-type(3) {
        background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1064' height='466' fill='none'%3E%3Cg clip-path='url(%23a)'%3E%3Crect width='728' height='455' fill='url(%23b)' rx='24' transform='matrix(.96593 -.25882 .7925 .60987 0 188.42)'/%3E%3Cg fill='%23033783'%3E%3Cpath fill-opacity='.2' d='M638.209-50.009C376.564 99.506 477.408 320.518 560.535 412.335L1063.78 277.49z'/%3E%3Cpath fill-opacity='.4' d='M711.119 6.099C494.132 130.043 577.63 313.21 646.503 389.3l417.277-111.81z'/%3E%3C/g%3E%3Cpath fill='%23003780' d='M791.162 67.695C624.04 163.343 688.839 304.87 742.129 363.677l321.651-86.187z'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='b' x1='72.545' x2='249.224' y1='26.435' y2='498.002' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%233382ea'/%3E%3Cstop offset='1' stop-color='%23003ea9'/%3E%3C/linearGradient%3E%3CclipPath id='a'%3E%3Crect width='728' height='455' fill='%23fff' rx='24' transform='matrix(.96593 -.25882 .7925 .60987 0 188.42)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E")
            0 0 no-repeat;
    }
    .adyen-checkout-ctp__card-animation > .adyen-checkout-ctp__card-animation-layer:nth-of-type(3) {
        animation: card-bounce 2.06s linear infinite both, card-fade-20 2.06s linear infinite both;
        opacity: 0.2;
        transform: translateY(50%);
        z-index: 1;
    }
    .adyen-checkout-ctp__loading-subtitle {
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin: 0 auto 58px;
        max-width: 280px;
        text-align: center;
    }
    .adyen-checkout-ctp__section > .adyen-checkout__field.adyen-checkout__field--shopperLogin {
        margin-bottom: var(--adyen-sdk-spacer-080, 20px);
    }
    .adyen-checkout__content-separator {
        align-items: center;
        color: var(--adyen-sdk-color-label-primary, #00112c);
        display: flex;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        justify-content: center;
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
        margin-top: var(--adyen-sdk-spacer-070, 16px);
        text-transform: capitalize;
        white-space: nowrap;
    }
    .adyen-checkout__content-separator:after,
    .adyen-checkout__content-separator:before {
        border-bottom: 1px solid var(--adyen-sdk-color-separator-primary, #dbdee2);
        content: '';
        flex: 1;
    }
    .adyen-checkout__content-separator:after {
        margin-left: var(--adyen-sdk-spacer-080, 20px);
    }
    .adyen-checkout__content-separator:before {
        margin-right: var(--adyen-sdk-spacer-080, 20px);
    }
    .adyen-checkout-link {
        --text-decoration: none;
        color: var(--adyen-sdk-color-label-highlight, #0070f5);
        -webkit-text-decoration: var(--text-decoration);
        text-decoration: var(--text-decoration);
    }
    .adyen-checkout-link:focus-visible {
        outline: none;
    }
    .adyen-checkout-link:active,
    .adyen-checkout-link:hover {
        --text-decoration: underline;
    }
    .adyen-checkout-link:focus-visible {
        border-radius: var(--adyen-sdk-border-radius-xs, 2px);
        box-shadow: 0 0 0 1px #fff,
            0 0 0 3px var(--adyen-sdk-focus-ring-color, rgba(0, 112, 245, 0.8));
        transition: 0.1s cubic-bezier(0.785, 0.135, 0.15, 0.86);
    }
    [class^='adyen-checkout'],
    [class^='adyen-checkout'] *,
    [class^='adyen-checkout'] :after,
    [class^='adyen-checkout'] :before,
    [class^='adyen-checkout']:after,
    [class^='adyen-checkout']:before {
        box-sizing: border-box;
    }
    .adyen-checkout__threeds2__challenge,
    .adyen-checkout__threeds2__challenge-container {
        background-color: transparent;
        display: block;
        height: inherit;
        min-height: 400px;
        overflow: hidden;
        position: relative;
        width: 100%;
    }
    .adyen-checkout__threeds2__challenge--01,
    .adyen-checkout__threeds2__challenge--01 .adyen-checkout__iframe--threeDSIframe {
        height: 400px;
        width: 250px;
    }
    .adyen-checkout__threeds2__challenge--02,
    .adyen-checkout__threeds2__challenge--02 .adyen-checkout__iframe--threeDSIframe {
        height: 400px;
        width: 390px;
    }
    .adyen-checkout__threeds2__challenge--03,
    .adyen-checkout__threeds2__challenge--03 .adyen-checkout__iframe--threeDSIframe {
        height: 600px;
        width: 500px;
    }
    .adyen-checkout__threeds2__challenge--04,
    .adyen-checkout__threeds2__challenge--04 .adyen-checkout__iframe--threeDSIframe {
        height: 400px;
        width: 600px;
    }
    .adyen-checkout__threeds2__challenge--05,
    .adyen-checkout__threeds2__challenge--05 .adyen-checkout__iframe--threeDSIframe {
        height: 100%;
        width: 100%;
    }
    .adyen-checkout__iframe--threeDSIframe {
        border: 0;
        left: 0;
        position: absolute;
        top: 0;
    }
    .adyen-checkout__threeds2-challenge-error .adyen-checkout__status__icon {
        display: block;
        margin: var(--adyen-sdk-spacer-130, 56px) auto var(--adyen-sdk-spacer-100, 32px);
    }
    .adyen-checkout__threeds2-challenge-error .adyen-checkout__status__text {
        color: var(--adyen-sdk-color-label-critical, #c72727);
        font-size: var(--adyen-sdk-text-title-font-size, 1rem);
        margin-bottom: var(--adyen-sdk-spacer-130, 56px);
        text-align: center;
    }
    .adyen-checkout__bacs--confirm {
        position: relative;
    }
    .adyen-checkout__bacs--confirm .adyen-checkout-input__inline-validation--valid {
        display: none;
    }
    .adyen-checkout__bacs .adyen-checkout__field--inactive {
        pointer-events: none;
    }
    .adyen-checkout__bacs .adyen-checkout__bacs--edit {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;
    }
    .adyen-checkout__bacs .adyen-checkout__bacs--edit-dropin {
        top: -50px;
    }
    .adyen-checkout__bacs .adyen-checkout__bacs--edit .adyen-checkout__bacs--edit-button {
        background: none;
        border: none;
        color: var(--adyen-sdk-color-label-primary, #00112c);
        cursor: pointer;
        padding: 0;
        text-align: end;
        text-decoration: underline;
    }
    .adyen-checkout__voucher-result {
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        position: relative;
        text-align: center;
    }
    .adyen-checkout__voucher-result__bottom,
    .adyen-checkout__voucher-result__top {
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-separator-primary, #dbdee2);
    }
    .adyen-checkout__voucher-result__top {
        border-bottom: 0;
        border-radius: var(--adyen-sdk-border-radius-m, 8px) var(--adyen-sdk-border-radius-m, 8px) 0
            0;
        padding: var(--adyen-sdk-spacer-110, 40px) 0 var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen-checkout__voucher-result__bottom {
        border-radius: 0 0 var(--adyen-sdk-border-radius-m, 8px)
            var(--adyen-sdk-border-radius-m, 8px);
        border-top: 0;
    }
    .adyen-checkout__voucher-result__separator {
        align-items: center;
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        display: flex;
        margin: 0 auto;
        position: relative;
    }
    .adyen-checkout__voucher-result__separator__inner {
        border-top: 1px solid var(--adyen-sdk-color-separator-primary, #dbdee2);
        width: 100%;
    }
    .adyen-checkout__voucher-result__image {
        align-items: center;
        display: flex;
        justify-content: center;
        margin-bottom: var(--adyen-sdk-spacer-110, 40px);
        width: 100%;
    }
    .adyen-checkout-link--voucher-result-instructions {
        display: inline-block;
    }
    .adyen-checkout__voucher-result__image__wrapper {
        display: block;
        height: var(--adyen-sdk-spacer-120, 48px);
        margin: 0 var(--adyen-sdk-spacer-090, 24px);
        position: relative;
    }
    .adyen-checkout__voucher-result__image__wrapper:after {
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        box-shadow: var(
            --adyen-sdk-shadow-low,
            0 2px 4px rgba(0, 17, 44, 0.04),
            0 1px 2px rgba(0, 17, 44, 0.02)
        );
        content: '';
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }
    .adyen-checkout__voucher-result__image__wrapper:nth-child(2) {
        margin-left: 0;
    }
    .adyen-checkout__voucher-result__image__brand,
    .adyen-checkout__voucher-result__image__issuer {
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        height: var(--adyen-sdk-spacer-120, 48px);
    }
    .adyen-checkout__voucher-result__introduction {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin: 0 auto;
        max-width: 400px;
        text-align: center;
    }
    .adyen-checkout__voucher-result__amount {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        font-weight: 700;
        margin: var(--adyen-sdk-spacer-090, 24px) auto 0;
        text-align: center;
    }
    .adyen-checkout__voucher-result__surcharge {
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        text-align: center;
    }
    .adyen-checkout__voucher-result__code__label,
    .adyen-checkout__voucher-result__surcharge {
        display: block;
        font-weight: 400;
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
    }
    .adyen-checkout__voucher-result__code__label {
        left: 0;
        margin: 0 auto;
        position: absolute;
        right: 0;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        width: auto;
    }
    .adyen-checkout__voucher-result__code__label:before {
        content: '';
        position: absolute;
    }
    .adyen-checkout__voucher-result__code__label__text {
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        letter-spacing: normal;
        line-height: 1;
        padding: 0 var(--adyen-sdk-spacer-040, 8px);
    }
    .adyen-checkout__voucher-result__code__barcode {
        display: block;
        height: var(--adyen-sdk-spacer-130, 56px);
        margin: 0 auto var(--adyen-sdk-spacer-040, 8px);
        max-width: 100%;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }
    .adyen-checkout__voucher-result__code {
        border-width: 1px 0;
        color: var(--adyen-sdk-color-label-primary, #00112c);
        display: inline-block;
        font-size: var(--adyen-sdk-text-title-l-font-size, 1.5rem);
        font-weight: 700;
        letter-spacing: 1px;
        line-height: 1.2;
        margin: 0 auto;
        padding: var(--adyen-sdk-spacer-070, 16px) var(--adyen-sdk-spacer-120, 48px);
        position: relative;
        text-align: center;
        -webkit-user-select: all;
        -moz-user-select: all;
        user-select: all;
        width: 100%;
        word-break: break-word;
    }
    .adyen-checkout__voucher-result__actions {
        align-items: center;
        display: flex;
        justify-content: center;
        list-style: none;
        margin: 0 auto var(--adyen-sdk-spacer-100, 32px);
        max-width: 100%;
        min-width: 200px;
        padding: 0;
        width: 300px;
    }
    .adyen-checkout__voucher-result__actions__item {
        margin: 0 var(--adyen-sdk-spacer-020, 4px);
    }
    .adyen-checkout__details-table {
        list-style: none;
        margin: -1px auto 0;
        padding: 0;
    }
    .adyen-checkout__details-table__item {
        border-top: 1px solid var(--adyen-sdk-color-separator-primary, #dbdee2);
        color: var(--adyen-sdk-color-label-primary, #00112c);
        display: flex;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        justify-content: space-between;
        padding: var(--adyen-sdk-spacer-070, 16px) var(--adyen-sdk-spacer-090, 24px);
        word-break: break-word;
    }
    .adyen-checkout__details-table__item:last-child {
        margin-bottom: 0;
    }
    .adyen-checkout__details-table__label {
        max-width: 50%;
        text-align: left;
    }
    .adyen-checkout__details-table__value {
        font-weight: 700;
        max-width: 50%;
        text-align: right;
    }
    .adyen-checkout__voucher-result__introduction {
        font-size: var(--adyen-sdk-text-title-font-size, 1rem);
        max-width: 420px;
    }
    .adyen-checkout__fieldset--personalDetails
        .adyen-checkout__field--gender
        .adyen-checkout__radio_group {
        display: flex;
    }
    .adyen-checkout__fieldset--personalDetails .adyen-checkout__radio_group {
        display: flex;
        margin: var(--adyen-sdk-spacer-040, 8px) 0;
    }
    .adyen-checkout__fieldset--personalDetails .adyen-checkout__radio_group__input-wrapper {
        margin-right: var(--adyen-sdk-spacer-080, 20px);
    }
    .adyen-checkout__fieldset--personalDetails
        .adyen-checkout__radio_group__input-wrapper:last-child {
        margin: 0;
    }
    .adyen-checkout__field--gender .adyen-checkout__input-wrapper {
        background-color: transparent;
        border: none;
        box-shadow: none;
    }
    .adyen-checkout__field--gender .adyen-checkout__input-wrapper:active,
    .adyen-checkout__field--gender .adyen-checkout__input-wrapper:active:hover,
    .adyen-checkout__field--gender .adyen-checkout__input-wrapper:focus-within,
    .adyen-checkout__field--gender .adyen-checkout__input-wrapper:focus-within:hover {
        box-shadow: none;
    }
    .adyen-checkout__field--separateDeliveryAddress .adyen-checkout__input-wrapper {
        background-color: transparent;
        border: none;
        box-shadow: none;
    }
    .adyen-checkout__field--separateDeliveryAddress .adyen-checkout__input-wrapper:active,
    .adyen-checkout__field--separateDeliveryAddress .adyen-checkout__input-wrapper:active:hover,
    .adyen-checkout__field--separateDeliveryAddress .adyen-checkout__input-wrapper:focus-within,
    .adyen-checkout__field--separateDeliveryAddress
        .adyen-checkout__input-wrapper:focus-within:hover {
        box-shadow: none;
    }
    .adyen-checkout__open-invoice .adyen-checkout__fieldset--billingAddress,
    .adyen-checkout__open-invoice .adyen-checkout__fieldset--personalDetails {
        padding-bottom: var(--adyen-sdk-spacer-040, 8px);
    }
    .adyen-checkout__open-invoice .adyen-checkout__fieldset--deliveryAddress {
        margin-top: var(--adyen-sdk-spacer-090, 24px);
        padding-bottom: var(--adyen-sdk-spacer-040, 8px);
    }
    .adyen-checkout__open-invoice .adyen-checkout__input--separateDeliveryAddress {
        margin-bottom: 0;
    }
    .adyen-checkout__open-invoice .adyen-checkout__field--consentCheckbox {
        margin-top: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__open-invoice--loading {
        pointer-events: none;
    }
    .adyen-checkout__amazonpay__button {
        margin: auto;
    }
    .adyen-checkout__amazonpay .adyen-checkout__button--ghost {
        display: block;
        margin: var(--adyen-sdk-spacer-040, 8px) auto 0;
        width: auto;
    }
    apple-pay-button {
        --apple-pay-button-width: 100%;
        --apple-pay-button-height: 48px;
        --apple-pay-button-border-radius: 4px;
    }
    .adyen-checkout__cashapp > .adyen-checkout__store-details {
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
        margin-top: 0;
    }
    .adyen-checkout__paywithgoogle {
        height: var(--adyen-sdk-spacer-120, 48px);
    }
    .adyen-checkout__paypal__buttons {
        position: relative;
        z-index: 0;
    }
    .adyen-checkout__paypal__button {
        display: flex;
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__paypal__button:empty {
        display: none;
    }
    .adyen-checkout__paypal__status--pending {
        margin: var(--adyen-sdk-spacer-070, 16px) 0;
    }
    .adyen-checkout__paypal__status--processing {
        align-items: center;
        display: flex;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        justify-content: center;
        padding: var(--adyen-sdk-spacer-090, 24px) 0;
    }
    .adyen-checkout__paypal-processing .adyen-checkout__paypal__button {
        display: none;
    }
    .adyen-checkout__payment-method .adyen-checkout__paypal__status--pending {
        margin: var(--adyen-sdk-spacer-070, 16px) 0 38px;
    }
    .adyen-checkout__payment-method .adyen-checkout__paypal__status--processing {
        padding: var(--adyen-sdk-spacer-080, 20px) 0 65px;
    }
    .adyen-checkout__field--sendCopyToEmail .adyen-checkout__input-wrapper {
        background-color: transparent;
        border: none;
        box-shadow: none;
    }
    .adyen-checkout__field--sendCopyToEmail .adyen-checkout__input-wrapper:active,
    .adyen-checkout__field--sendCopyToEmail .adyen-checkout__input-wrapper:active:hover,
    .adyen-checkout__field--sendCopyToEmail .adyen-checkout__input-wrapper:focus-within,
    .adyen-checkout__field--sendCopyToEmail .adyen-checkout__input-wrapper:focus-within:hover {
        box-shadow: none;
    }
    .adyen-checkout__voucher-result--boletobancario .adyen-checkout__voucher-result__code {
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        padding: var(--adyen-sdk-spacer-090, 24px);
        word-break: break-all;
    }
    .adyen-checkout__voucher-result--oxxo .adyen-checkout__voucher-result__code {
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        padding: var(--adyen-sdk-spacer-090, 24px);
        word-break: break-all;
    }
    .adyen-checkout__issuer-button {
        align-items: center;
        background-color: var(--adyen-sdk-color-background-primary, #ffffff);
        border: none;
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        box-shadow: inset 0 0 0 1px var(--adyen-sdk-color-outline-primary, #dbdee2);
        cursor: pointer;
        display: flex;
        flex-basis: 47%;
        flex-grow: 2;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        height: var(--adyen-sdk-spacer-110, 40px);
        justify-content: space-between;
        padding: var(--adyen-sdk-spacer-000, 0) var(--adyen-sdk-spacer-060, 12px);
        transition: background 0.3s ease-out, box-shadow 0.3s ease-out;
    }
    .adyen-checkout__issuer-button:active {
        color: var(--adyen-sdk-color-label-primary, #00112c);
    }
    .adyen-checkout__issuer-button:not(.adyen-checkout__issuer-button--selected):focus {
        box-shadow: inset 0 0 0 1px var(--adyen-sdk-color-outline-tertiary, #8d95a3);
        outline: none;
    }
    .adyen-checkout__issuer-button:not(.adyen-checkout__issuer-button--selected):focus-visible {
        box-shadow: inset 0 0 0 1px var(--adyen-sdk-color-outline-tertiary, #8d95a3);
        outline: none;
    }
    .adyen-checkout__issuer-button:not(.adyen-checkout__issuer-button--selected):hover {
        box-shadow: inset 0 0 0 1px var(--adyen-sdk-color-outline-tertiary, #8d95a3);
        outline: none;
    }
    .adyen-checkout__issuer-button--selected {
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        box-shadow: inset 0 0 0 1.5px var(--adyen-sdk-color-outline-primary-active, #00112c);
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
        height: var(--adyen-sdk-spacer-110, 40px);
        transition: none;
    }
    .adyen-checkout__issuer-button-img {
        margin-right: var(--adyen-sdk-spacer-040, 8px);
        max-height: 26px;
    }
    .adyen-checkout__issuer-button-group {
        display: flex;
        flex-wrap: wrap;
        gap: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__field--issuer-list {
        margin-bottom: 0;
    }
    .adyen-checkout__econtext-input__field > .adyen-checkout__button--pay:only-child {
        margin-top: 0;
    }
    .adyen-checkout-trustly {
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout-trustly__descriptor {
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
        margin: var(--adyen-sdk-spacer-000, 0) var(--adyen-sdk-spacer-000, 0)
            var(--adyen-sdk-spacer-020, 4px);
    }
    .adyen-checkout-trustly__description-list {
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        line-height: 1.5;
        list-style-type: disc;
        margin: 0;
        padding-left: var(--adyen-sdk-spacer-080, 20px);
    }
    .adyen-checkout-paybybank_AIS_DD {
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout-paybybank_AIS_DD__description-header {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
        margin: var(--adyen-sdk-spacer-000, 0) var(--adyen-sdk-spacer-000, 0)
            var(--adyen-sdk-spacer-020, 4px);
    }
    .adyen-checkout-paybybank_AIS_DD__description-body {
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        line-height: 1.5;
        list-style-type: disc;
        margin: 0;
    }
    @media (max-width: 330px) {
        .adyen-checkout__payment-method--paybybank_AIS_DD
            .adyen-checkout__payment-method__brands
            .adyen-checkout__payment-method__image__wrapper:nth-child(2) {
            display: none;
        }
    }
    @media (max-width: 360px) {
        .adyen-checkout__payment-method--paybybank_AIS_DD
            .adyen-checkout__payment-method__brands
            .adyen-checkout__payment-method__image__wrapper:nth-child(3) {
            display: none;
        }
    }
    @media (max-width: 390px) {
        .adyen-checkout__payment-method--paybybank_AIS_DD
            .adyen-checkout__payment-method__brands
            .adyen-checkout__payment-method__image__wrapper:nth-child(4) {
            display: none;
        }
    }
    .adyen-checkout__payment-method--paybybank_AIS_DD
        .adyen-checkout__payment-method__brand-number {
        text-overflow: clip;
        white-space: nowrap;
    }
    .adyen-checkout__klarna-widget {
        pointer-events: all;
    }
    .adyen-checkout__qr-loader {
        align-items: center;
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-secondary, #c9cdd3);
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        display: flex;
        flex-direction: column;
        padding: var(--adyen-sdk-spacer-110, 40px);
        padding-bottom: var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen-checkout__qr-loader--result {
        gap: var(--adyen-sdk-spacer-090, 24px);
        padding: 100px;
    }
    .adyen-checkout__qr-loader--app {
        border: 0;
        border-radius: 0;
        padding: 0;
    }
    .adyen-checkout__qr-loader__brand-logo-wrapper {
        border-radius: var(--adyen-sdk-border-radius-s, 4px);
        box-shadow: var(
            --adyen-sdk-shadow-low,
            0 2px 4px rgba(0, 17, 44, 0.04),
            0 1px 2px rgba(0, 17, 44, 0.02)
        );
        margin-bottom: var(--adyen-sdk-spacer-090, 24px);
        overflow: hidden;
    }
    .adyen-checkout__qr-loader__brand-logo {
        display: block;
        width: 80px;
    }
    .adyen-checkout__qr-loader__subtitle {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        line-height: var(--adyen-sdk-text-body-line-height, 20px);
        max-width: 400px;
        text-align: center;
    }
    .adyen-checkout__qr-loader__icon {
        height: 88px;
        width: 88px;
    }
    .adyen-checkout__qr-loader__payment_amount {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-title-l-font-size, 1.5rem);
        font-weight: var(--adyen-sdk-text-title-l-font-weight, 600);
        line-height: var(--adyen-sdk-text-body-wide-line-height, 24px);
        margin-bottom: var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen-checkout__qr-loader__progress {
        background: var(--adyen-sdk-color-outline-secondary, #c9cdd3);
        border-radius: var(--adyen-sdk-border-radius-l, 12px);
        height: var(--adyen-sdk-spacer-020, 4px);
        margin-bottom: var(--adyen-sdk-spacer-060, 12px);
        padding-right: 3%;
        width: 152px;
    }
    [dir='rtl'] .adyen-checkout__qr-loader__progress {
        padding-left: 3%;
        padding-right: 0;
    }
    .adyen-checkout__qr-loader__percentage {
        background: var(--adyen-sdk-color-label-primary, #00112c);
        border-radius: var(--adyen-sdk-border-radius-l, 12px);
        display: block;
        height: 100%;
    }
    .adyen-checkout__qr-loader__countdown {
        font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
        text-align: center;
    }
    .adyen-checkout__qr-loader > .adyen-checkout__spinner__wrapper {
        margin: 60px 0;
    }
    .adyen-checkout__qr-loader__app-link {
        display: none;
    }
    .adyen-checkout__button.adyen-checkout__button--qr-loader {
        margin-top: var(--adyen-sdk-spacer-090, 24px);
        text-decoration: none;
    }
    .adyen-checkout__qr-loader__instructions {
        color: var(--adyen-sdk-color-label-tertiary, #5c687c);
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        line-height: 1.5;
        margin-top: var(--adyen-sdk-spacer-090, 24px);
        max-width: 300px;
    }
    .adyen-checkout__qr-loader__actions {
        align-items: center;
        display: flex;
        justify-content: center;
        margin-top: var(--adyen-sdk-spacer-100, 32px);
    }
    .adyen-checkout__await__instructions {
        display: flex;
        justify-content: center;
    }
    @media (max-width: 1024px) {
        .adyen-checkout__qr-loader__app-link {
            display: block;
            min-width: 220px;
        }
    }
    .adyen-checkout__qr-loader--swish > .adyen-checkout__qr-loader__instructions {
        text-align: center;
    }
    .adyen-checkout-paynow__introduction {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        line-height: var(--adyen-sdk-text-body-line-height, 20px);
        text-align: center;
    }
    .adyen-checkout-timeline-wrapper {
        background-color: var(--adyen-sdk-color-background-secondary, #f7f7f8);
        border-radius: 8px;
        max-width: 300px;
        padding: 16px;
    }
    .adyen-checkout-timeline {
        scrollbar-color: var(--adyen-sdk-color-background-quaternary, #c0c5cc) transparent;
    }
    .adyen-checkout-timeline__items {
        all: unset;
    }
    .adyen-checkout-timeline-item {
        scrollbar-color: var(--adyen-sdk-color-background-quaternary, #c0c5cc) transparent;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        list-style-type: none;
        max-width: 500px;
    }
    .adyen-checkout-timeline-item:last-child .adyen-checkout-timeline-item__separator {
        display: none;
    }
    .adyen-checkout-timeline-item:last-child .adyen-checkout-timeline-item__content {
        padding-bottom: 0;
    }
    .adyen-checkout-timeline-item__row {
        display: flex;
        gap: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout-timeline-item__marker {
        display: flex;
        flex-flow: column;
        margin-top: var(--adyen-sdk-spacer-010, 2px);
        max-width: var(--adyen-sdk-spacer-070, 16px);
        width: 100%;
    }
    .adyen-checkout-timeline-item__separator {
        flex-grow: 1;
        position: relative;
    }
    .adyen-checkout-timeline-item__separator:before {
        background-color: var(--adyen-sdk-color-separator-secondary, #c9cdd3);
        content: '';
        height: 100%;
        left: 50%;
        position: absolute;
        transform: translate(-50%);
        width: 1px;
    }
    .adyen-checkout-timeline-item__content {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        padding-bottom: var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout-timeline-item__title {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        letter-spacing: 0;
        line-height: var(--adyen-sdk-text-body-line-height, 20px);
        margin-bottom: var(--adyen-sdk-spacer-010, 2px);
        text-align: left;
    }
    .adyen-checkout-paynow__instructions {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        line-height: var(--adyen-sdk-text-body-line-height, 20px);
        text-align: center;
    }
    .adyen-checkout-paynow__instructions > p {
        margin-bottom: 0;
    }
    .adyen-checkout__blik__helper {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        font-weight: 400;
        margin: 0 0 var(--adyen-sdk-spacer-070, 16px);
        padding: 0;
    }
    .adyen-checkout__await {
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-secondary, #c9cdd3);
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        padding: var(--adyen-sdk-spacer-110, 40px);
        text-align: center;
    }
    .adyen-checkout__await--result {
        padding: 100px;
    }
    .adyen-checkout__qr-loader--app {
        border: 0;
        border-radius: 0;
        padding: 0;
    }
    .adyen-checkout__await__brand-logo {
        border-radius: 3px;
        width: 74px;
    }
    .adyen-checkout__await__indicator-text,
    .adyen-checkout__await__subtitle {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin-top: var(--adyen-sdk-spacer-100, 32px);
    }
    .adyen-checkout__await__indicator-holder .adyen-checkout__await__indicator-text {
        margin-left: var(--adyen-sdk-spacer-050, 10px);
        margin-top: var(--adyen-sdk-spacer-030, 6px);
    }
    .adyen-checkout__await__indicator-holder {
        display: flex;
        justify-content: center;
        margin-bottom: var(--adyen-sdk-spacer-080, 20px);
        margin-top: var(--adyen-sdk-spacer-100, 32px);
    }
    .adyen-checkout__await__subtitle--result {
        margin-bottom: var(--adyen-sdk-spacer-100, 32px);
    }
    .adyen-checkout__await__icon {
        height: 88px;
        width: 88px;
    }
    .adyen-checkout__await__progress {
        background: var(--adyen-sdk-color-outline-secondary, #c9cdd3);
        border-radius: var(--adyen-sdk-border-radius-l, 12px);
        height: var(--adyen-sdk-spacer-020, 4px);
        margin: var(--adyen-sdk-spacer-100, 32px) auto var(--adyen-sdk-spacer-060, 12px);
        width: 152px;
    }
    .adyen-checkout__await__percentage {
        background: var(--adyen-sdk-color-label-primary, #00112c);
        border-radius: var(--adyen-sdk-border-radius-l, 12px);
        display: block;
        height: 100%;
    }
    .adyen-checkout__await__countdown {
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
    }
    .adyen-checkout__await > .adyen-checkout__spinner__wrapper {
        margin: 60px 0;
    }
    .adyen-checkout__await__app-link {
        display: none;
        margin-top: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__await__amount {
        font-size: var(--adyen-sdk-text-title-l-font-size, 1.5rem);
        font-weight: var(--adyen-sdk-text-title-font-weight, 600);
        margin-top: var(--adyen-sdk-spacer-070, 16px);
        text-align: center;
    }
    @media only screen and (max-device-width: 1200px) {
        .adyen-checkout__await__app-link {
            display: block;
        }
    }
    .adyen-checkout__loading-input__form {
        transition: opacity 0.25s ease-out;
    }
    .adyen-checkout__fieldset--phone-input {
        direction: ltr;
    }
    .adyen-checkout__fieldset--phone-input .adyen-checkout__fieldset__fields {
        gap: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__fieldset--phone-input
        .adyen-checkout__fieldset__fields
        > .adyen-checkout__field {
        margin-bottom: 0;
    }
    .adyen-checkout-field--phone-prefix {
        width: 144px;
    }
    .adyen-checkout-field--phone-number {
        flex: 1;
    }
    .adyen-checkout__field--vpa {
        margin-bottom: 0;
    }
    .adyen-checkout_upi-mode-selection-text {
        font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
        font-weight: var(--adyen-sdk-text-caption-font-weight, 400);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin-bottom: var(--adyen-sdk-spacer-040, 8px);
        margin-top: var(--adyen-sdk-spacer-000, 0);
    }
    .adyen-checkout__segmented-control--upi-margin-bottom {
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout-upi-area-intent .adyen-checkout__button--pay {
        margin-top: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout-upi-area-qr-code .adyen-checkout__button--pay {
        margin-top: var(--adyen-sdk-spacer-000, 0);
    }
    .adyen-checkout-checkmark {
        border-bottom: 1.5px solid var(--adyen-sdk-color-label-primary, #00112c);
        border-right: 1.5px solid var(--adyen-sdk-color-label-primary, #00112c);
        height: var(--adyen-sdk-spacer-060, 12px);
        transform: rotate(45deg);
        width: var(--adyen-sdk-spacer-030, 6px);
    }
    .adyen-checkout__segmented-control {
        background: var(--adyen-sdk-color-background-tertiary, #eeeff1);
        border-radius: var(--adyen-sdk-border-radius-l, 12px);
        display: flex;
        gap: var(--adyen-sdk-spacer-020, 4px);
        justify-content: space-between;
        padding: var(--adyen-sdk-spacer-030, 6px);
    }
    .adyen-checkout__segmented-control--disabled {
        pointer-events: none;
    }
    .adyen-checkout__segmented-control--disabled > .adyen-checkout__segmented-control-segment {
        color: var(--adyen-sdk-color-label-disabled, #8d95a3);
    }
    .adyen-checkout__segmented-control--disabled
        > .adyen-checkout__segmented-control-segment--selected
        .adyen-checkout-checkmark {
        border-bottom: 1.5px solid var(--adyen-sdk-color-label-disabled, #8d95a3);
        border-right: 1.5px solid var(--adyen-sdk-color-label-disabled, #8d95a3);
    }
    .adyen-checkout__segmented-control-segment {
        align-items: center;
        background: transparent;
        border: 0;
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        color: var(--adyen-sdk-color-label-primary, #00112c);
        cursor: pointer;
        display: flex;
        flex-grow: 1;
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
        gap: var(--adyen-sdk-spacer-050, 10px);
        height: var(--adyen-sdk-spacer-110, 40px);
        justify-content: center;
        text-align: center;
        transition: background 0.3s ease-out;
        width: 100%;
    }
    .adyen-checkout__segmented-control-segment:active,
    .adyen-checkout__segmented-control-segment:not(
            .adyen-checkout__segmented-control-segment--selected
        ):hover {
        background-color: var(--adyen-sdk-color-background-secondary, #f7f7f8);
    }
    .adyen-checkout__segmented-control-segment--selected {
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        box-shadow: var(
            --adyen-sdk-shadow-low,
            0 2px 4px rgba(0, 17, 44, 0.04),
            0 1px 2px rgba(0, 17, 44, 0.02)
        );
        color: var(--adyen-sdk-color-label-primary, #00112c);
    }
    .adyen-checkout__payment-method__header__title {
        align-items: center;
        background: none;
        border: none;
        color: var(--adyen-sdk-color-label-primary, #00112c);
        cursor: pointer;
        display: flex;
        flex-shrink: 0;
        font-size: 1em;
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
        gap: var(--adyen-sdk-spacer-060, 12px);
        margin-right: var(--adyen-sdk-spacer-070, 16px);
        max-height: 38px;
        max-width: 100%;
        padding: 0;
    }
    [dir='rtl'] .adyen-checkout__payment-method__header__title {
        margin-left: var(--adyen-sdk-spacer-070, 16px);
        margin-right: var(--adyen-sdk-spacer-000, 0);
    }
    .adyen-checkout__payment-method__radio {
        background-color: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-secondary, #c9cdd3);
        border-radius: 50%;
        height: var(--adyen-sdk-spacer-070, 16px);
        left: var(--adyen-sdk-spacer-070, 16px);
        transition: border-color 0.2s ease-out, box-shadow 0.2s ease-out;
        width: var(--adyen-sdk-spacer-070, 16px);
    }
    [dir='rtl'] .adyen-checkout__payment-method__radio {
        left: auto;
        right: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__payment-method__radio:after {
        background-color: var(--adyen-sdk-color-background-primary, #ffffff);
        border-radius: 50%;
        content: '';
        display: block;
        height: var(--adyen-sdk-spacer-040, 8px);
        left: 0;
        margin: 0 auto;
        position: relative;
        right: 0;
        top: 50%;
        transform: translateY(-50%) scale(0);
        transition: transform 0.3s ease-out;
        width: var(--adyen-sdk-spacer-040, 8px);
    }
    .adyen-checkout__payment-method__radio--selected {
        background-color: var(--adyen-sdk-color-label-primary, #00112c);
        border: 0;
        transition: all 0.3s ease-out;
    }
    .adyen-checkout__payment-method__radio--selected:hover {
        box-shadow: 0 0 0 var(--adyen-sdk-spacer-010, 2px)
            var(--adyen-sdk-color-outline-primary-hover, #c9cdd3);
    }
    .adyen-checkout__payment-method__radio--selected:after {
        transform: translateY(-50%) scale(1);
    }
    .adyen-checkout-upi-app-item {
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-primary, #dbdee2);
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        cursor: pointer;
        display: flex;
        flex-direction: column;
        gap: var(--adyen-sdk-spacer-070, 16px);
        padding: var(--adyen-sdk-spacer-050, 10px) var(--adyen-sdk-spacer-070, 16px);
        transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease,
            box-shadow 0.15s ease, border-radius 0.15s ease;
        width: 100%;
    }
    .adyen-checkout-upi-app-item__label {
        cursor: pointer;
    }
    .adyen-checkout-upi-app-item:hover:not(.adyen-checkout-upi-app-item--selected) {
        border-color: var(--adyen-sdk-color-outline-primary-hover, #c9cdd3);
    }
    .adyen-checkout-upi-app-item--selected:not(.adyen-checkout-upi-app-item:last-child) {
        border-color: var(--adyen-sdk-color-outline-primary-active, #00112c);
        box-shadow: 0 0 0 0.5px var(--adyen-sdk-color-outline-primary-active, #00112c);
    }
    .adyen-checkout-upi-app-item--selected {
        border-color: var(--adyen-sdk-color-outline-secondary, #c9cdd3);
        cursor: default;
    }
    .adyen-checkout-upi-app-item--selected .adyen-checkout-expand-button--upi-app-item,
    .adyen-checkout-upi-app-item--selected .adyen-checkout-expand-button--upi-app-item > label {
        cursor: default;
    }
    .adyen-checkout-upi-app-item .adyen-checkout-expand-button--upi-app-item {
        margin-right: 0;
    }
    .adyen-checkout-upi-app-list {
        display: flex;
        flex-direction: column;
        gap: var(--adyen-sdk-spacer-070, 16px);
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .adyen-checkout-upi-app-list--loading {
        pointer-events: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }
    .adyen-checkout__payto-component .adyen-checkout__fieldset {
        margin-top: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__payto-component .adyen-checkout__fieldset .adyen-checkout__fieldset__fields {
        gap: 0 var(--adyen-sdk-spacer-060, 12px);
        margin-top: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__payto-component .adyen-checkout-field--phone-prefix {
        width: 98px;
    }
    .adyen-checkout__payto-component--loading {
        pointer-events: none;
    }
    .adyen-checkout__await--payto .adyen-checkout__details-table {
        margin-top: var(--adyen-sdk-spacer-070, 16px);
        padding-top: var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout__await--payto .adyen-checkout__details-table__item:first-of-type {
        border-top: none;
    }
    .adyen-checkout__alert-message {
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        display: flex;
        font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
        margin: 0 0 var(--adyen-sdk-spacer-070, 16px);
        padding: var(--adyen-sdk-spacer-060, 12px);
        text-align: left;
    }
    .adyen-checkout__alert-message--error {
        background: var(--adyen-sdk-color-background-critical-strong, #e22d2d);
    }
    .adyen-checkout__alert-message--info {
        background: var(--adyen-sdk-color-background-secondary, #f7f7f8);
    }
    .adyen-checkout__alert-message__icon {
        height: 14px;
        margin-right: var(--adyen-sdk-spacer-040, 8px);
        width: 14px;
    }
    .adyen-checkout__giftcard-result__header {
        align-items: center;
        display: flex;
        flex-wrap: nowrap;
        font-size: var(--adyen-sdk-text-title-font-size, 1rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        justify-content: space-between;
        position: relative;
        width: 100%;
    }
    .adyen-checkout__giftcard-result__header__title {
        align-items: center;
        display: flex;
    }
    .adyen-checkout__giftcard-result__name {
        margin-left: var(--adyen-sdk-spacer-040, 8px);
    }
    .adyen-checkout__giftcard-result__balance {
        list-style: none;
        margin: var(--adyen-sdk-spacer-070, 16px) 0 0;
        padding: 0;
    }
    .adyen-checkout__giftcard-result__balance__item {
        display: flex;
        justify-content: space-between;
        margin-bottom: var(--adyen-sdk-spacer-040, 8px);
    }
    .adyen-checkout__giftcard-result__balance__item
        .adyen-checkout__giftcard-result__balance__title--transactionLimit {
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
    }
    .adyen-checkout__giftcard-result__balance__item:last-child {
        margin-bottom: 0;
    }
    .adyen-checkout__giftcard-result__balance__value--amount {
        font-weight: 700;
    }
    .adyen-checkout__giftcard-result__remaining-balance {
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        margin: var(--adyen-sdk-spacer-040, 8px) auto 0;
        text-align: center;
    }
    .adyen-checkout__bankTransfer__introduction {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        margin: 0 0 var(--adyen-sdk-spacer-070, 16px);
        padding: 0;
    }
    .adyen-checkout__bankTransfer__emailField {
        margin: 0 0 var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__adyen-giving .adyen-checkout__status__icon {
        display: block;
        margin: var(--adyen-sdk-spacer-130, 56px) auto var(--adyen-sdk-spacer-100, 32px);
    }
    .adyen-checkout__adyen-giving .adyen-checkout__status__text {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        margin-bottom: var(--adyen-sdk-spacer-130, 56px);
        text-align: center;
    }
    .adyen-checkout__adyen-giving .adyen-checkout-disclaimer__label {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        margin-top: 0;
    }
    .adyen-checkout__campaign {
        position: relative;
    }
    .adyen-checkout__campaign-link:hover .adyen-checkout__campaign-description {
        text-decoration: underline;
    }
    .adyen-checkout__campaign-logo {
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-primary, #dbdee2);
        border-radius: var(--adyen-sdk-border-radius-s, 4px);
        display: block;
        flex-shrink: 0;
        height: var(--adyen-sdk-spacer-120, 48px);
        -o-object-fit: cover;
        object-fit: cover;
        -o-object-position: center;
        object-position: center;
        overflow: hidden;
        width: var(--adyen-sdk-spacer-120, 48px);
    }
    .adyen-checkout__campaign-background-image {
        aspect-ratio: 5/2;
        background-color: var(--adyen-sdk-color-label-primary, #00112c);
        background-position: 50%;
        background-size: 100%;
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        margin-bottom: var(--adyen-sdk-spacer-060, 12px);
        overflow: hidden;
        transition: background-size 0.6s ease-out;
    }
    .adyen-checkout__campaign-background-image:hover {
        background-size: 110%;
    }
    .adyen-checkout__campaign-link {
        text-decoration: none;
    }
    .adyen-checkout__campaign-link:hover {
        text-decoration: underline;
    }
    .adyen-checkout__campaign-content {
        align-items: flex-start;
        display: flex;
        gap: var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout__campaign-description,
    .adyen-checkout__campaign-title {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        margin: 0;
    }
    .adyen-checkout__campaign-title {
        font-size: var(--adyen-sdk-text-title-font-size, 1rem);
        font-weight: var(--adyen-sdk-text-title-font-weight, 600);
        line-height: var(--adyen-sdk-text-title-line-height, 26px);
    }
    .adyen-checkout__campaign-cause {
        font-weight: var(--adyen-sdk-text-caption-font-weight, 400);
        font-weight: var(--adyen-sdk-text-caption-stronger-font-weight, 500);
    }
    .adyen-checkout__campaign-cause,
    .adyen-checkout__campaign-description {
        font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
    }
    .adyen-checkout__campaign-description {
        font-weight: var(--adyen-sdk-text-caption-font-weight, 400);
        margin-top: var(--adyen-sdk-spacer-060, 12px);
    }
    .adyen-checkout-roundup-description {
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
        display: inline-block;
        font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
        font-weight: var(--adyen-sdk-text-caption-font-weight, 400);
        line-height: var(--adyen-sdk-text-caption-line-height, 18px);
        padding-left: 0;
    }
    .adyen-checkout__adyen-giving-actions {
        display: flex;
        flex-direction: column;
        gap: var(--adyen-sdk-spacer-070, 16px);
        margin-top: var(--adyen-sdk-spacer-070, 16px);
        text-align: center;
    }
    .adyen-checkout__button.adyen-checkout__button--donate {
        margin: var(--adyen-sdk-spacer-000, 0);
    }
    .adyen-checkout__button.adyen-checkout__button--decline {
        display: block;
        margin: auto;
    }
    .adyen-checkout__button-group {
        background: transparent;
        display: flex;
        justify-content: space-between;
    }
    .adyen-checkout__button-group .adyen-checkout__button {
        background: transparent;
        border: 0;
        box-shadow: inset 0 0 0 1px var(--adyen-sdk-color-outline-primary, #dbdee2);
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        font-weight: 400;
        height: var(--adyen-sdk-spacer-110, 40px);
        line-height: var(--adyen-sdk-spacer-110, 40px);
        margin-right: var(--adyen-sdk-spacer-040, 8px);
        padding: 0;
        text-align: center;
    }
    .adyen-checkout__button-group .adyen-checkout__button:last-child {
        margin-right: 0;
    }
    .adyen-checkout__button-group .adyen-checkout__button:hover {
        background: transparent;
        box-shadow: inset 0 0 0 var(--adyen-sdk-spacer-010, 2px)
            var(--adyen-sdk-color-outline-primary-hover, #c9cdd3);
    }
    .adyen-checkout__button-group .adyen-checkout__button:active {
        background: var(--adyen-sdk-color-background-secondary, #f7f7f8);
        box-shadow: inset 0 0 0 var(--adyen-sdk-spacer-010, 2px)
            var(--adyen-sdk-color-outline-tertiary, #8d95a3);
    }
    .adyen-checkout__button-group .adyen-checkout__button--disabled,
    .adyen-checkout__button-group .adyen-checkout__button--disabled:hover {
        cursor: not-allowed;
        opacity: 0.4;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }
    .adyen-checkout__button-group .adyen-checkout__button--selected,
    .adyen-checkout__button-group .adyen-checkout__button--selected:active,
    .adyen-checkout__button-group .adyen-checkout__button--selected:active:hover,
    .adyen-checkout__button-group .adyen-checkout__button--selected:hover {
        background: var(--adyen-sdk-color-background-secondary, #f7f7f8);
        box-shadow: inset 0 0 0 1px var(--adyen-sdk-color-label-primary, #00112c);
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
        height: var(--adyen-sdk-spacer-110, 40px);
        transition: none;
    }
    .adyen-checkout__button-group .adyen-checkout__button .adyen-checkout__button-group__input {
        opacity: 0;
        pointer-events: none;
        position: absolute;
    }
    .adyen-checkout__order-payment-methods-list {
        list-style: none;
        margin: 0 auto var(--adyen-sdk-spacer-070, 16px);
        padding: 0;
    }
    .adyen-checkout__order-payment-method {
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-tertiary, #8d95a3);
        margin-top: -1px;
        position: relative;
        width: 100%;
    }
    .adyen-checkout__order-payment-method:first-of-type {
        border-top-left-radius: var(--adyen-sdk-border-radius-m, 8px);
        border-top-right-radius: var(--adyen-sdk-border-radius-m, 8px);
    }
    .adyen-checkout__order-payment-method:last-child {
        border-bottom-left-radius: var(--adyen-sdk-border-radius-m, 8px);
        border-bottom-right-radius: var(--adyen-sdk-border-radius-m, 8px);
    }
    .adyen-checkout__order-payment-method__header {
        align-items: center;
        color: var(--adyen-sdk-color-label-primary, #00112c);
        display: flex;
        flex-wrap: nowrap;
        font-size: var(--adyen-sdk-text-title-font-size, 1rem);
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
        justify-content: space-between;
        padding: var(--adyen-sdk-spacer-070, 16px);
        position: relative;
        transition: background 0.1s ease-out;
        width: 100%;
    }
    .adyen-checkout__order-payment-method__header .adyen-checkout__payment-method__header__title {
        padding: var(--adyen-sdk-spacer-000, 0);
    }
    .adyen-checkout__order-payment-method__details {
        padding: 0 var(--adyen-sdk-spacer-070, 16px) var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__order-payment-method__deducted-amount {
        display: flex;
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        justify-content: space-between;
        line-height: var(--adyen-sdk-text-subtitle-font-size, 1rem);
    }
    .adyen-checkout__order-payment-method__deducted-amount__label {
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
    }
    .adyen-checkout__order-payment-method__deducted-amount__value {
        font-weight: var(--adyen-sdk-text-body-stronger-font-weight, 500);
    }
    .adyen-checkout__order-remaining-amount {
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
        display: block;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        padding: var(--adyen-sdk-spacer-040, 8px) var(--adyen-sdk-spacer-070, 16px);
        width: 100%;
    }
    .adyen-checkout__order-remaining-amount strong {
        font-weight: 700;
    }
    .adyen-checkout__dropin--loading .adyen-checkout__instant-payment-methods-list {
        opacity: 0.2;
        pointer-events: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }
    .adyen-checkout__payment-method__disable-confirmation {
        background: var(--adyen-sdk-color-background-critical-strong, #e22d2d);
        border-left: 1px solid #e12424;
        border-right: 1px solid #e12424;
        color: var(--adyen-sdk-color-label-on-color, #ffffff);
        display: grid;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        grid-template-rows: 0fr;
        margin: 0 -17px;
        opacity: 0;
        overflow: hidden;
        transition: grid-template-rows var(--adyen-sdk-animation-duration-moderate, 0.15s)
                var(--adyen-sdk-animation-easing-linear, linear),
            opacity var(--adyen-sdk-animation-duration-moderate, 0.15s)
                var(--adyen-sdk-animation-easing-standard, cubic-bezier(0.2, 0, 0.4, 0.9)),
            margin-bottom var(--adyen-sdk-animation-duration-fast, 0.1s)
                var(--adyen-sdk-animation-easing-linear, linear);
    }
    .adyen-checkout__payment-method__disable-confirmation__content {
        align-items: center;
        display: flex;
        justify-content: space-between;
        min-height: 0;
        transition: visibility var(--adyen-sdk-animation-duration-moderate, 0.15s)
                var(--adyen-sdk-animation-easing-linear, linear),
            padding var(--adyen-sdk-animation-duration-fast, 0.1s)
                var(--adyen-sdk-animation-easing-linear, linear);
        visibility: hidden;
    }
    .adyen-checkout__payment-method__disable-confirmation--open {
        grid-template-rows: 1fr;
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
        opacity: 1;
    }
    .adyen-checkout__payment-method__disable-confirmation--open
        .adyen-checkout__payment-method__disable-confirmation__content {
        padding: var(--adyen-sdk-spacer-040, 8px) var(--adyen-sdk-spacer-070, 16px);
        visibility: visible;
    }
    .adyen-checkout__payment-method__disable-confirmation__buttons {
        display: flex;
    }
    .adyen-checkout__payment-method__disable-confirmation__button {
        background: var(--adyen-sdk-color-background-critical-strong, #e22d2d);
        border: var(--adyen-sdk-border-width-s, 1px) solid transparent;
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        color: var(--adyen-sdk-color-label-on-color, #ffffff);
        cursor: pointer;
        display: block;
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
        height: auto;
        margin: 0 0 0 var(--adyen-sdk-spacer-040, 8px);
        padding: var(--adyen-sdk-spacer-040, 8px);
        width: auto;
    }
    .adyen-checkout__payment-method__disable-confirmation__button:hover,
    .adyen-checkout__payment-method__disable-confirmation__button:hover:focus {
        background: #d81e1e;
        box-shadow: none;
    }
    .adyen-checkout__payment-method__disable-confirmation__button:active,
    .adyen-checkout__payment-method__disable-confirmation__button:hover:active {
        background: #c11b1b;
        box-shadow: none;
    }
    .adyen-checkout__payment-method__disable-confirmation__button--remove,
    .adyen-checkout__payment-method__disable-confirmation__button--remove:disabled {
        border-color: var(--adyen-sdk-color-label-on-color, #ffffff);
    }
    .adyen-checkout__payment-method__disable-confirmation__button--cancel,
    .adyen-checkout__payment-method__disable-confirmation__button--cancel:disabled {
        border-color: transparent;
    }
    .adyen-checkout__payment-method {
        background: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-primary, #dbdee2);
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        cursor: pointer;
        position: relative;
        transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease,
            box-shadow 0.15s ease, border-radius 0.15s ease;
        width: 100%;
    }
    .adyen-checkout__payment-method:focus {
        outline: 0;
    }
    .adyen-checkout__payment-method:hover:not(.adyen-checkout__payment-method--selected) {
        border-color: var(--adyen-sdk-color-outline-primary-hover, #c9cdd3);
    }
    .adyen-checkout__payment-method--loading {
        opacity: 0.2;
    }
    .adyen-checkout__payment-method--selected.adyen-checkout__payment-method--loading {
        opacity: 0.9;
    }
    .adyen-checkout__payment-method--confirming .adyen-checkout__payment-method__details__content,
    .adyen-checkout__payment-method--disabling {
        pointer-events: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }
    .adyen-checkout__payment-method--disabling {
        opacity: 0.3;
    }
    .adyen-checkout__payment-method--standalone .adyen-checkout__payment-method__radio {
        display: none;
    }
    .adyen-checkout__payment-method__header {
        align-items: center;
        color: var(--adyen-sdk-color-label-primary, #00112c);
        display: flex;
        flex-wrap: nowrap;
        font-size: var(--adyen-sdk-text-title-font-size, 1rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
        justify-content: space-between;
        padding: var(--adyen-sdk-spacer-070, 16px);
        position: relative;
        transition: background 0.1s ease-out;
        width: 100%;
    }
    [dir='rtl'] .adyen-checkout__payment-method__header {
        padding: calc(var(--adyen-sdk-spacer-070, 16px) - var(--adyen-sdk-spacer-020, 4px));
        padding-right: calc(var(--adyen-sdk-spacer-120, 48px) - var(--adyen-sdk-spacer-020, 4px));
    }
    .adyen-checkout__payment-method--standalone .adyen-checkout__payment-method__header {
        padding: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__payment-method__surcharge {
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
        margin-left: var(--adyen-sdk-spacer-020, 4px);
    }
    .adyen-checkout__payment-method--selected {
        background: var(--adyen-sdk-color-background-secondary, #f7f7f8);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-secondary, #c9cdd3);
        cursor: default;
        transition: opacity 0.3s ease-out;
    }
    .adyen-checkout__payment-method--selected .adyen-checkout__payment-method__header {
        flex-wrap: wrap;
    }
    .adyen-checkout__payment-method__details {
        padding: var(--adyen-sdk-spacer-000, 0) var(--adyen-sdk-spacer-070, 16px);
        position: relative;
    }
    .adyen-checkout__payment-method__details__content > :last-child {
        margin-bottom: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout__payment-method__image__wrapper {
        align-items: center;
        border-radius: var(--adyen-sdk-border-radius-s, 4px);
        box-shadow: var(
            --adyen-sdk-shadow-low,
            0 2px 4px rgba(0, 17, 44, 0.04),
            0 1px 2px rgba(0, 17, 44, 0.02)
        );
        display: flex;
        height: 26px;
        justify-content: center;
        overflow: hidden;
        position: relative;
        width: var(--adyen-sdk-spacer-110, 40px);
    }
    .adyen-checkout__payment-method__image {
        border-radius: var(--adyen-checkout-border-radius-s);
        display: block;
        flex-shrink: 0;
        height: 100%;
        overflow: hidden;
        width: 100%;
    }
    .adyen-checkout__payment-method__brands {
        display: flex;
        flex-basis: auto;
        flex-shrink: 1;
        flex-wrap: wrap;
        gap: var(--adyen-sdk-spacer-020, 4px);
        height: var(--adyen-sdk-spacer-070, 16px);
        margin: var(--adyen-sdk-spacer-020, 4px) var(--adyen-sdk-spacer-000, 0);
        overflow: hidden;
        text-align: right;
    }
    .adyen-checkout__payment-method__brands .adyen-checkout__payment-method__brand-number {
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
        font-size: var(--adyen-sdk-text-body-font-size, 0.875rem);
    }
    .adyen-checkout__payment-method--selected .adyen-checkout__payment-method__brands {
        height: auto;
        overflow: visible;
        text-align: left;
    }
    .adyen-checkout__payment-method__brands .adyen-checkout__payment-method__image__wrapper {
        display: inline-block;
        height: var(--adyen-sdk-spacer-070, 16px);
        transition: opacity 0.2s ease-out;
        width: var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen-checkout__payment-method__brands
        .adyen-checkout__payment-method__image__wrapper:last-child {
        margin: var(--adyen-sdk-spacer-000, 0);
    }
    .adyen-checkout__payment-method--selected
        .adyen-checkout__payment-method__brands
        .adyen-checkout__payment-method__image__wrapper {
        margin-bottom: var(--adyen-sdk-spacer-020, 4px);
    }
    .adyen-checkout__payment-method__brands img {
        display: block;
        height: 100%;
        width: 100%;
    }
    .adyen-checkout__payment-method__image__wrapper--disabled {
        opacity: 0.25;
    }
    .adyen-checkout__payment-method:hover:not(.adyen-checkout__payment-method--selected)
        .adyen-checkout__payment-method__radio {
        box-shadow: 0 0 0 var(--adyen-sdk-spacer-010, 2px)
            var(--adyen-sdk-color-outline-primary-hover, #c9cdd3);
        cursor: pointer;
    }
    .adyen-checkout__payment-method__name {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
    }
    .adyen-checkout__payment-method__additional-info {
        color: var(--adyen-sdk-color-label-secondary, #5c687c);
        font-size: var(--adyen-sdk-text-caption-font-size, 0.75rem);
        font-weight: var(--adyen-sdk-text-body-font-weight, 400);
    }
    .adyen-checkout__payment-method__name_wrapper {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        gap: var(--adyen-sdk-spacer-020, 4px);
        min-width: var(--adyen-sdk-spacer-120, 48px);
        text-align: start;
    }
    .adyen-checkout__status {
        align-items: center;
        background-color: var(--adyen-sdk-color-background-primary, #ffffff);
        border: var(--adyen-sdk-border-width-s, 1px) solid
            var(--adyen-sdk-color-outline-secondary, #c9cdd3);
        border-radius: var(--adyen-sdk-border-radius-m, 8px);
        color: var(--adyen-sdk-color-label-primary, #00112c);
        display: flex;
        flex-direction: column;
        font-size: var(--adyen-sdk-text-title-font-size, 1rem);
        height: 350px;
        justify-content: center;
        margin: 0;
        padding: var(--adyen-sdk-spacer-100, 32px);
        text-align: center;
    }
    .adyen-checkout__status__icon {
        margin-bottom: var(--adyen-sdk-spacer-090, 24px);
    }
    .adyen-checkout__status .adyen-checkout__spinner__wrapper {
        max-height: 88px;
    }
    .adyen-checkout__dropin {
        display: flex;
        flex-direction: column;
        gap: var(--adyen-sdk-spacer-100, 32px);
    }
    .adyen-checkout-payment-methods-container {
        display: flex;
        flex-direction: column;
        gap: var(--adyen-sdk-spacer-070, 16px);
    }
    .adyen-checkout-payment-methods-list-label {
        color: var(--adyen-sdk-color-label-primary, #00112c);
        font-size: var(--adyen-sdk-text-subtitle-font-size, 1rem);
        font-weight: var(--adyen-sdk-text-subtitle-stronger-font-weight, 600);
        line-height: var(--adyen-sdk-text-subtitle-line-height, 26px);
    }
    .adyen-checkout__payment-methods-list {
        display: flex;
        flex-direction: column;
        gap: var(--adyen-sdk-spacer-070, 16px);
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .adyen-checkout__payment-methods-list--loading {
        pointer-events: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }
    .adyen-checkout__instant-payment-methods-list {
        display: flex;
        flex-wrap: wrap;
        gap: var(--adyen-sdk-spacer-070, 16px);
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .adyen-checkout__instant-payment-methods-list li {
        flex: 1 0 calc(50% - var(--adyen-sdk-spacer-070, 16px) / 2);
    }
    .adyen-checkout__payment-method {
        display: block;
    }
    .adyen-checkout__payment-method__details {
        overflow: hidden;
    }
    .adyen-checkout__payment-method__image {
        height: 26px;
        width: var(--adyen-sdk-spacer-110, 40px);
    }
    [dir='rtl'] .adyen-checkout__payment-method__image__wrapper {
        margin-left: var(--adyen-sdk-spacer-040, 8px);
        margin-right: 0;
    }
    .adyen-checkout-pm-details-wrapper {
        display: grid;
        grid-template-rows: 0fr;
        transition: grid-template-rows 0.25s ease;
        visibility: hidden;
    }
    .adyen-checkout-pm-details-wrapper[aria-hidden='false'] {
        grid-template-rows: 1fr;
        visibility: visible;
    }
    .adyen-checkout-pm-details-wrapper[aria-hidden='false']
        .adyen-checkout__payment-method__details {
        overflow: visible;
    }
    .adyen-checkout-sr-panel {
        font-size: 0.75em;
        margin-bottom: var(--adyen-sdk-spacer-080, 20px);
    }
    .adyen-checkout-sr-panel--sr-only {
        border: 0;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
    }
`

export default adyen_css
